import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Chip from 'material-ui/Chip';
import MuiButton from 'material-ui/Button';
import Wrapper from '../common/Wrapper';
import Header from '../common/Header';
import Button from '../Parts/Button';
import Loader from '../Parts/Loader';
import CancelCircle from '../Icons/CancelCircle';
import Chat from '../Icons/Chat';
import NotificationBar from '../Parts/NotificationBar.jsx'
import NotificationBanner from '../common/NotificationBanner';
import IsMaxLetterSendingNotification from '../common/UnDeletableNotification/IsMaxLetterSendingNotification';
import IsMaxExportExecutiveListNotification from '../common/UnDeletableNotification/IsMaxExportExecutiveListNotification';
import ArrowLeft from '../Icons/ArrowLeft';
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import ListSettingDialog from './dialogs/ListSettingDialog';
import BottomButtonMenu from '../common/BottomButtonMenu';
import ExecListSidebar from './ExecListSidebar';
import ChatDrawer from './controls/ChatDrawer';
import SalesforceSyncWarningDialog from "./dialogs/SalesforceSyncWarningDialog";
import ConfirmSendDialog from '../common/ConfirmSendDialog';
import {
  sentStatusMenu,
  corporationSentStatusMenu,
  excludeRetirementMenu,
  jsicMenu,
  capSortMenu,
} from '../../constants/SidebarValues';
import { generateConfigInitialState } from '../../constants/ExecutiveListSearchKeyConstants';
import NoMatchCorporationCsvExportPanel from './panels/NoMatchCorporationCsvExportPanel';
import ExportCountNoticePanel from './panels/ExportCountNoticePanel';
import AddressTable from './AddressTable';
import SaveFilterDialog from './dialogs/SaveFilterDialog';
import EditFilterDialog from './dialogs/EditFilterDialog';
import ExecDetailItemDialog from './dialogs/ExecDetailItemDialog/ExecDetailItemDialog';
import DailyNotificationDialog from './dialogs/DailyNotificationDialog';
import PromotePlanChangeDialog from '../common/PromotePlanChangeDialog';
import SelectOptionDialog from '../common/SelectOptionDialog';
import InfoBox from './dialogs/InfoBox';
import Banner from './dialogs/Banner';
import Pagination from '../common/Pagination';
import ManageTagsDialog from '../AddressBook/dialogs/ManageTagsDialog';
import EditTagsDialog from '../AddressBook/dialogs/EditTagsDialog';
import CreateListDialog from '../AddressBook/dialogs/CreateListDialog';
import CsvDownloadDialog from '../AddressBook/dialogs/CsvDownloadDialog';
import AttackListGeneratorDialog from './dialogs/AttackListGeneratorDialog';
import { addCommas, convertFilterValuesToNestedMap, flattenMap, generateCapSizePerCorporationMenu ,isEnabledUserRole, difference, isMinLetterOrderCount } from '../../utils/utils';
import { isPlanExpired } from '../../utils/userUtils';
import { compressSelectionToNodes, getAllLeafIds } from '../../utils/treeUtils';
import { isEnabledExportExecutiveList, isEnabledSendLetter, isEnabledDisplayExecutiveList, isFreePlan } from '../../utils/planUtils';
import { buildGoBackToExecutiveDetailParams, buildCorporationRelationshipsKeymanParams, getIntentKeywordMaps, formatIntentKeywords } from '../../utils/executiveListUtils';
import { ADDRESS_PER_PAGE, KEYMAN_COPY_DAILY_LIMIT, KEYMAN_COPY_LOG_INTERVAL_AFTER_LIMIT } from '../../constants/Constants';
import { incrementTodayCopyCount, isCopyCountOverLimit } from '../../utils/copyDetectionUtils';
import { ExecSortType, TagType, PromotePlanDialogTypes } from '../../constants/ComponentTypes'
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import * as moment from 'moment';
import {
  MAP_MENU_CONFIG,
  MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG,
  DAILY_NOTIFICATION_FILTER_CONFIG,
  KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG,
  USER_LIST_FILTER_CONFIG,
  HIERARCHICAL_MENU_CONFIG,
  KEYWORD_SEARCH_CONFIG,
  KEYWORD_SEARCH_IS_AND_CONFIG,
  CORPORATION_RELATIONSHIPS_CONFIG,
  CORPORATION_RELATIONSHIPS_LABEL_CONFIG,
  SIMPLE_MENU_FILTER_CONFIG,
  FUNDRAISING_FILTER_CONFIG,
  INDUSTRY_SEARCH_MODE_CONFIG
} from '../../constants/ExecutiveListSearchKeyConstants';

const { Set, Map, OrderedSet } = require('immutable');

const styles = () => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#F4F6F9",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },

  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },

  sidebar: {
    backgroundColor: '#FFFFFF',
    minWidth: '300px',
    maxWidth: '300px',
    width: '300px',
    overflowX: "hidden",
    flex: '1',
    marginTop: '20px',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
    zIndex: 2,
  },

  mainContainer: {
    flex: '4',
    position: 'relative',
    overflowY: 'hidden',
    boxSizing: 'border-box',
    padding: '0',
    display: 'flex',
  },

  middleContainer: {
    flex: '3',
    padding: '20px',
    overflowY: 'scroll',
  },

  mainPanelHeaderWrap: {
    padding: '15px 20px 10px 30px',
    boxSizing: 'border-box',
    background: '#FFFFFF',
    display: 'flex',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
    justifyContent: 'space-between',
  },

  mainPanelHeader: {
    padding: '10px 20px 15px 0px',
    display: 'flex',
  },

  mainPanelCountContent: {
    alignItems: 'flex-end',
    display: 'flex',
    marginTop: '8px',
  },

  mainPanel: {
    margin: '10px 0px 20px 0px',
    boxSizing: 'border-box',
    position: 'relative',
  },

  paginationContainer: {
    margin: '40px 0px 80px 0px',
  },

  bottomMenu: {
    width: "calc(100% - 300px)",
    position: 'fixed',
    bottom: 0,
    marginLeft: '-20px',
    zIndex: 1,
  },

  chatButton: {
    position: 'fixed',
    bottom: '24px',
    left: '24px',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: '#1537A6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#0F2875',
      boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2)',
    },
  },

  chipRoot: {
    marginRight: '10px',
    marginTop: '8px',
    float: 'left',
    backgroundColor: 'rgba(26,101,255,.05)',
    border: '#1A65FF solid 1px',
    color: '#181819',
    height: '27px',
    borderRadius: '2px',
  },

  chipLabel: {
    padding: '5px 17px 5px 10px',
    fontSize: '11px',
  },

  chipContainer: {
    marginLeft: '50px',
  },

  header: {
    height: "60px",
    color: "#FFFFFF",
    background: "#040E35",
    zIndex: 1,
    display: 'flex',
    alignItems: 'center'
  },

  backBtn: {
    margin: 0,
    height: '60px',
    width: '60px',
    minWidth: 'unset',
    borderRight: '1px solid #232941',
    fontSize: 13,
  },

  title: {
    marginLeft: '20px',
    flex: 1,
    color: "#FFFFFF",
  },

  headerButton: {
    border: "1px solid #FFFFFF",
    color: '#FFFFFF',
    marginRight: '20px',
    fontSize: '13px',
  },

  errorMessageRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "2px",
  },
});

// create a value to entry reverse map out of industryMenu
const capSizePerCorporationMenu = generateCapSizePerCorporationMenu();

class ExecutiveList extends React.Component {
  initialState = {
    selectedItems: Set(),
    selectedItemsMap: Map(), // "/send-letter"に遷移しないアカウントのみで使用します。/send-letterに遷移で使用するアカウントでページに戻る際、数値が初期化されます。handleFilterSelectedで再設定はできません。
    unselectedItems: Set(),
    exportedList: Map(),
    isSelectAll: false,
    filterValue: {
      cap_size_per_corporation: "0",
      cap_sort_first_preferred: "0",
      cap_sort_second_preferred: "0",
      cap_priority: Set(),
      relocation_at: Map(),
      timeline_status: Map(),
      sent_status: Map(),
      sent_only_from: '',
      sent_only_to: '',
      sent_except_from: '',
      sent_except_to: '',
      corporation_sent_status: Map(),
      corporation_sent_only_from: '',
      corporation_sent_only_to: '',
      corporation_sent_except_from: '',
      corporation_sent_except_to: '',
      follow_call_order_status: Map(),
      follow_call_order_only_from: '',
      follow_call_order_only_to: '',
      follow_call_order_except_from: '',
      follow_call_order_except_to: '',
      download_status: Map(),
      corporate_number: OrderedSet(),
      company_name: OrderedSet(),
      exclude_retirement: [true].toString(), //デフォルト値は「退任した人を含めない」
      exclude_retirement_risk: false,
      exclude_registered_address: false,
      unique_per_corporation: false,
      show_recently_created: false,
      show_yesterday_created: false,
      exists_corporation_department_tels_filter: false,
      include_field_call_analysis_ids: false,
      is_include_consolidated_search_number_of_employees: true,
      // 各設定から動的に生成された初期状態を追加
      ...generateConfigInitialState(HIERARCHICAL_MENU_CONFIG),
      ...generateConfigInitialState(MAP_MENU_CONFIG),
      ...generateConfigInitialState(USER_LIST_FILTER_CONFIG),
      ...generateConfigInitialState(KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG),
      ...generateConfigInitialState(SIMPLE_MENU_FILTER_CONFIG),
      ...generateConfigInitialState(KEYWORD_SEARCH_CONFIG),
      ...generateConfigInitialState(KEYWORD_SEARCH_IS_AND_CONFIG),
      ...generateConfigInitialState(CORPORATION_RELATIONSHIPS_CONFIG),
      ...generateConfigInitialState(CORPORATION_RELATIONSHIPS_LABEL_CONFIG),
      ...generateConfigInitialState(DAILY_NOTIFICATION_FILTER_CONFIG),
      ...generateConfigInitialState(FUNDRAISING_FILTER_CONFIG),
      ...generateConfigInitialState(INDUSTRY_SEARCH_MODE_CONFIG),
    },
    sortType: ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value,
    perPage: ADDRESS_PER_PAGE,
    step: 0,
    selectCount: 0,
    selectedFilter: "選択してください",
    showSaveFilterDialog: false,
    message: '',
    messageType: 'success',
    showNotification: false,
    showEditFilterDialog: false,
    showExecDetailItemDialog: false,
    showSelectOptionDialog: false,
    showPlanDialog: false,
    showManageTagsDialog: false,
    showEditTagsDialog: false,
    showCreateListDialog: false,
    showCsvDownloadDialog: false,
    showListSettingDialog: false,
    [PromotePlanDialogTypes.REACTION_KEYWORD.flag]: false,
    [PromotePlanDialogTypes.DEPARTMENT_TEL.flag]: false,
    showSalesforceSyncWarningDialog: false,
    showExportCountNotice: true,
    showDailyNotificationDialog: this.props.cookies.get('showDailyNotificationDialog') === '0' ? false : true,
    showConfirmSendDialog: false,
    isSearchCompany: false,
    showRightPanel: false,
    showInfoBox: this.props.cookies.get('showInfoBox') === '0' ? false : this.props.showInfoBox,
    showBanner: this.props.cookies.get('showBanner') === '0' ? false : this.props.showInfoBox,
    isPageLoaded: false,
    item: null,
    duplicateNames: [],
    hasLetterOrderHistoryNames: [],
    isLoadingCheck: false,
    showNoMatchCorporationCsvExportPanel: false,
    showChatDrawer: false,
    chatMessages: [],
    isInitialMessageShown: false,
    isChatLoading: false,
    // AIチャットの会話（複数保持）。conversations=[{id,title,messages,isInitialMessageShown,updatedAt}]
    conversations: [],
    currentConversationId: null,
    showAttackListGeneratorDialog: false,
    hotScoreTagName: null,  // ホット順ソート用のAI生成タグ名
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  handleChatDrawerToggle = () => {
    const isOpening = !this.state.showChatDrawer;
    this.setState({ showChatDrawer: isOpening }, () => {
      // 開くタイミングで初期メッセージ（挨拶）が未表示なら表示する
      if (isOpening) {
        this.showChatInitialMessage();
      }
    });
  }

  // テキストを受け取って送信するユーティリティ（ChatDrawer の非制御 input 用）
  // 送信時に build_conditions/ai を叩き、レスポンスの intent で挙動を3分岐する（intentが無ければ従来のhas_conditionsで判定）。
  //  - conditions : ドロワーを閉じ、生成された conditions を既存フィルタに反映して通常検索を実行
  //  - recommend  : /search/ai を呼び、レコメンド結果をチャットに表示する（ドロワーは閉じない）
  //  - clarify    : 検索もレコメンドもせず、聞き直しメッセージをチャットに表示する（ドロワーは閉じない）
  sendMessageWithText = (text, includeWebDiscovery = false) => {
    const chatInput = String(text);
    if (chatInput.trim() === '') return;

    // 送信時点の会話を確定して捕捉する（応答が別会話へ混入しないように）
    const conversationId = this.ensureCurrentConversation();

    const newMessage = {
      id: this.generateMessageId(),
      text: chatInput,
      sender: 'user',
      timestamp: new Date()
    };

    this.appendMessageToConversation(conversationId, newMessage, { isChatLoading: true });

    // 自然文から検索条件を生成するAI APIを呼び出す
    this.props.postExecutiveListBuildConditionsAi(chatInput)
      .then((response) => {
        const data = response && response.data ? response.data : {};

        // 概念の代表企業を特定できなかった場合（unresolved_universe）:
        // preview は基本 null / has_conditions=false。検索もレコメンドも出さず、注意書きのみ表示する。
        const unresolvedUniverse = typeof data.unresolved_universe === 'string' && data.unresolved_universe.trim() !== ''
          ? data.unresolved_universe.trim() : '';
        if (unresolvedUniverse) {
          this.appendMessageToConversation(conversationId, {
            id: this.generateMessageId(),
            text: `「${unresolvedUniverse}」に該当する代表企業を特定できませんでした。条件を変えてお試しください。`,
            sender: 'bot',
            timestamp: new Date()
          }, { isChatLoading: false });
          return;
        }

        // intent(conditions/recommend/clarify/status)を優先。想定外の値や未指定のときは
        // 従来の has_conditions で判定する（後方互換）。true→conditions / false→recommend。
        // ※バックエンドが intent の綴りを変えた場合は recommend にフォールバックする点に注意。
        const intent = ['conditions', 'recommend', 'clarify', 'status'].indexOf(data.intent) >= 0
          ? data.intent
          : (data.has_conditions === true ? 'conditions' : 'recommend');

        if (intent === 'conditions') {
          // 条件を生成できた場合
          const conditions = data.conditions && typeof data.conditions === 'object' ? data.conditions : {};
          // summary はそのまま表示する。末尾の「※ 〜」の行はバックエンドからの注意書き（非対応の並び順、
          // 条件に使わなかった関係・開示書類のキーワードなど）で、ユーザーが絞り込まれたと誤解しないよう消さない
          const summary = typeof data.summary === 'string' ? data.summary.trim() : '';
          const unmapped = Array.isArray(data.unmapped) ? data.unmapped : [];

          // AIが生成した検索条件は、キーワード（空白区切り）の結合を基本OR検索にする。
          // ただしバックエンドが is_and_search_* を明示している場合はその指定を尊重する。
          // （filterValueの初期値はAND=trueのため、明示指定がないキーワードはここでORへ倒す）
          const conditionsWithOr = { ...conditions };
          Object.keys(KEYWORD_SEARCH_IS_AND_CONFIG).forEach((isAndKey) => {
            const keywordKey = isAndKey.replace('is_and_search_', '');
            const hasKeyword = typeof conditionsWithOr[keywordKey] === 'string' && conditionsWithOr[keywordKey] !== '';
            const isSpecifiedByBackend = Object.prototype.hasOwnProperty.call(conditionsWithOr, isAndKey);
            if (hasKeyword && !isSpecifiedByBackend) {
              conditionsWithOr[isAndKey] = 'false'; // OR検索
            }
          });

          // プレビュー: intent=conditions のときのみ preview が入る（失敗時は null）
          const preview = data.preview && typeof data.preview === 'object' ? data.preview : null;

          if (preview) {
            // プレビュー表示フロー: ドロワーは閉じず、preview.items を一覧表示し「全てを見る」で本検索する
            const previewItems = Array.isArray(preview.items) ? preview.items : [];
            const previewTotal = typeof preview.total === 'number' ? preview.total : previewItems.length;

            let botText = summary !== '' ? `以下の条件でプレビューを表示します。\n${summary}` : '以下の条件でプレビューを表示します。';
            if (unmapped.length > 0) {
              botText += `\n以下は条件に反映できませんでした: ${unmapped.join('、')}`;
            }

            this.appendMessageToConversation(conversationId, {
              id: this.generateMessageId(),
              text: botText,
              sender: 'bot',
              timestamp: new Date(),
              // プレビュー用データ（「全てを見る」で本検索する）
              isConditionsPreview: true,
              previewItems: previewItems,
              previewTotal: previewTotal,
              previewConditions: conditionsWithOr,
              previewSummary: summary,
              previewUnmapped: unmapped,
            }, { isChatLoading: false });
            return;
          }

          // preview が無い場合は従来どおり（ドロワーを閉じてフィルタ反映＋検索）
          let botText = summary !== '' ? `以下の条件で検索しました。\n${summary}` : 'この条件で検索しました。';
          if (unmapped.length > 0) {
            botText += `\n以下は条件に反映できませんでした: ${unmapped.join('、')}`;
          }
          this.appendMessageToConversation(conversationId, {
            id: this.generateMessageId(),
            text: botText,
            sender: 'bot',
            timestamp: new Date(),
          }, {
            isChatLoading: false,
            showChatDrawer: false,
          });

          // 送信元が現在の会話でない（応答待ち中に別会話へ切り替えた）場合は、
          // ドロワーを閉じる・検索を実行する等のUI副作用を行わない（現在会話の画面を汚さない）。
          if (conversationId !== this.state.currentConversationId) {
            return;
          }
          this.applyAiConditionsAndSearch(conditionsWithOr, unmapped);
        } else if (intent === 'status') {
          // 稼働状況の照会（例:「今何件コールしてる？」）: 回答文(message)と構造化データ(status_result)を表示する（ドロワーは開いたまま）
          const message = typeof data.message === 'string' && data.message !== ''
            ? data.message
            : '稼働状況を取得できませんでした。もう一度お試しください。';
          const statusResult = data.status_result && typeof data.status_result === 'object' ? data.status_result : null;
          this.appendMessageToConversation(conversationId, {
            id: this.generateMessageId(),
            text: message,
            sender: 'bot',
            timestamp: new Date(),
            isStatusResult: statusResult !== null,
            statusResult: statusResult,
          }, { isChatLoading: false });
        } else if (intent === 'clarify') {
          // 入力が曖昧/意味不明: 検索もレコメンドもせず、聞き直しメッセージをチャット表示する（ドロワーは開いたまま）
          const message = typeof data.message === 'string' && data.message !== ''
            ? data.message
            : '検索条件として認識できませんでした。探したいキーマンの条件（業種・役職・企業規模など）や、提案したい商材について教えてください。';
          this.appendMessageToConversation(conversationId, {
            id: this.generateMessageId(),
            text: message,
            sender: 'bot',
            timestamp: new Date()
          }, { isChatLoading: false });
        } else {
          // recommend: 既存のレコメンドAI(/search/ai)を呼び、結果をチャットに表示する（検索条件は設定しない）
          // トグルONのときは外部探索(include_web_discovery)を明示的に有効にする
          this.runRecommendation(chatInput, includeWebDiscovery, conversationId);
        }
      })
      .catch(() => {
        this.appendMessageToConversation(conversationId, {
          id: this.generateMessageId(),
          text: '申し訳ございません。エラーが発生しました。もう一度お試しください。',
          sender: 'bot',
          timestamp: new Date()
        }, { isChatLoading: false });
      });
  }

  // AI生成の検索条件をフィルタに反映して通常検索を実行する（ドロワーを閉じる想定は呼び出し側）。
  applyAiConditionsAndSearch = (conditionsWithOr, unmapped = []) => {
    // conditions（/executive_list/search と同一形式）を filterValue に反映し検索を実行
    // （既存フィルタは置換＝上書き。handleFilterSelected が初期stateからの復元＋検索まで行う）
    this.handleFilterSelected(conditionsWithOr);

    // トーストは短い確認メッセージのみ表示する。反映できなかった条件(unmapped)がある場合のみ併記する。
    let notificationMessage = 'この条件で検索しました';
    let notificationType = 'success';
    if (Array.isArray(unmapped) && unmapped.length > 0) {
      notificationMessage += `（以下は条件に反映できませんでした: ${unmapped.join('、')}）`;
      notificationType = 'yellow';
    }
    this.displayNotification(notificationMessage, notificationType);
  };

  // プレビューの「全てを見る」押下: ドロワーを閉じて conditions で本検索を実行する
  handleSeeAllConditions = (conditions, unmapped = []) => {
    if (!conditions || typeof conditions !== 'object') return;
    this.setState({ showChatDrawer: false }, () => {
      this.applyAiConditionsAndSearch(conditions, unmapped);
    });
  };

  // レコメンド(/search/ai)を呼び出し、結果をチャットに表示する。
  // build_conditions/ai が recommend の場合に使用する。
  // conversationId: 送信元の会話ID（応答が別会話へ混入しないように特定して追記する）
  // ※呼び出し元で isChatLoading=true を立てた状態で呼ぶこと（完了時にここで false へ戻す）
  runRecommendation = (chatInput, includeWebDiscovery = false, conversationId = null) => {
    const targetConversationId = conversationId || this.state.currentConversationId;
    this.props.postExecutiveListSearchAi(chatInput, includeWebDiscovery)
      .then((httpResponse) => {
        // 競合(連続送信での取り違え)を避けるため、Reduxのpropsではなく解決値を直接使う
        const response = httpResponse && httpResponse.data ? httpResponse.data : null;
        let responseText = 'ご質問ありがとうございます。担当者が確認次第、お返事いたします。';
        let responseItems;
        let responseWebCandidates;
        let responseRoleGapCandidates;

        if (response) {
          if (typeof response === 'string') {
            responseText = response;
          } else if (typeof response === 'object') {
            // type(message_only / recommended_executive_list 等)に依らず、
            // reason(リスト全体の根拠) → message の順で「値」を本文テキストとして扱う。
            // （キー名「message」やオブジェクト自体を素朴に表示しないよう、JSON.stringifyのフォールバックは行わない）
            const nested = response.data && typeof response.data === 'object' ? response.data : null;
            if (typeof response.reason === 'string' && response.reason.trim() !== '') {
              // レコメンド一覧の全体根拠。空文字は0件時なので採用しない（次点のmessage等にフォールバック）
              responseText = response.reason;
            } else if (typeof response.message === 'string') {
              responseText = response.message;
            } else if (typeof response.text === 'string') {
              responseText = response.text;
            } else if (typeof response.output === 'string') {
              responseText = response.output;
            } else if (typeof response.data === 'string') {
              responseText = response.data;
            } else if (nested && typeof nested.message === 'string') {
              responseText = nested.message;
            } else if (nested && typeof nested.text === 'string') {
              responseText = nested.text;
            }
            // いずれの本文も取得できない場合は、初期の定型文(responseText)のまま表示する。

            if (Array.isArray(response.items) && response.items.length > 0) {
              responseItems = response.items;
            } else if (nested && Array.isArray(nested.items) && nested.items.length > 0) {
              responseItems = nested.items;
            }

            // レコメンド(items)が0件の場合は、専用の「見つかりませんでした」メッセージにする。
            // （items配列が存在するのに空 = レコメンド結果0件。message_onlyはitems配列自体が無いので対象外）
            const itemsField = Array.isArray(response.items) ? response.items
              : (nested && Array.isArray(nested.items) ? nested.items : null);
            if (itemsField && itemsField.length === 0) {
              responseText = 'おすすめの決裁者が見つかりませんでした。';
            }

            // Web検索で見つけたKDB外の候補企業（レコメンドの追加セクション）
            if (Array.isArray(response.web_candidates) && response.web_candidates.length > 0) {
              responseWebCandidates = response.web_candidates;
            } else if (nested && Array.isArray(nested.web_candidates) && nested.web_candidates.length > 0) {
              responseWebCandidates = nested.web_candidates;
            }

            // 役職欠損企業（企業はKDBにあるが該当役職の人だけWebで補完した候補）
            if (Array.isArray(response.role_gap_candidates) && response.role_gap_candidates.length > 0) {
              responseRoleGapCandidates = response.role_gap_candidates;
            } else if (nested && Array.isArray(nested.role_gap_candidates) && nested.role_gap_candidates.length > 0) {
              responseRoleGapCandidates = nested.role_gap_candidates;
            }
          }
        }

        // Web補完が非同期ジョブ化されたため、pending のときはトークンでポーリングして後追い取得する
        const webCompletionPending = response && typeof response === 'object'
          && response.web_completion_pending === true
          && typeof response.web_job_token === 'string' && response.web_job_token !== '';
        const webJobToken = webCompletionPending ? response.web_job_token : null;

        const messageId = this.generateMessageId();
        const botMessage = {
          id: messageId,
          text: String(responseText),
          sender: 'bot',
          timestamp: new Date(),
          items: responseItems,
          webCandidates: responseWebCandidates,
          roleGapCandidates: responseRoleGapCandidates,
          webCompletionPending: webCompletionPending,
        };
        this.appendMessageToConversation(targetConversationId, botMessage, { isChatLoading: false });

        // Web補完ジョブがある場合は web_result を ready までポーリングする
        if (webCompletionPending) {
          this.pollWebResult(targetConversationId, messageId, webJobToken, 0);
        }
      })
      .catch(() => {
        this.appendMessageToConversation(targetConversationId, {
          id: this.generateMessageId(),
          text: '申し訳ございません。エラーが発生しました。もう一度お試しください。',
          sender: 'bot',
          timestamp: new Date()
        }, { isChatLoading: false });
      });
  }

  // 指定した会話内の特定メッセージ(messageId)を updater で更新する。
  // 対象が現在の会話なら chatMessages を、別会話なら conversations の該当会話を更新する。
  updateMessageInConversation = (conversationId, messageId, updater) => {
    const applyUpdate = (messages) => (Array.isArray(messages) ? messages : []).map(m => m.id === messageId ? updater(m) : m);
    this.setState(prev => {
      if (prev.currentConversationId === conversationId) {
        return { chatMessages: applyUpdate(prev.chatMessages) };
      }
      const conversations = prev.conversations.map(c => c.id === conversationId
        ? { ...c, messages: applyUpdate(c.messages), updatedAt: Date.now() }
        : c);
      return { conversations };
    }, () => {
      this.persistChat();
    });
  };

  // Web補完結果ポーリング用タイマー（アンマウント時に解除するため保持）
  webResultTimers = [];
  // Web補完のセクション種別（この順に ready になっていく）
  WEB_RESULT_SECTIONS = ['enriched_items', 'web_candidates', 'role_gap_candidates'];

  // web_result のレスポンスを対象メッセージへ反映する（セクション単位の逐次表示）。
  // opts.finished=true のとき、まだ pending のセクションを failed（取得失敗/タイムアウト）にする。
  applyWebResultSections = (conversationId, messageId, data, opts = {}) => {
    // ジョブ失敗(failed)＝エラー表示。overallReady/timedOut は「完了扱い（0件は空状態）」とする。
    const jobFailed = !!(opts && opts.failed);
    const timedOut = !!(opts && opts.timedOut);
    const hasSections = data && data.sections && typeof data.sections === 'object';
    const sections = hasSections ? data.sections : {};
    const overallReady = data && data.ready === true;
    // sections が無い旧レスポンスは overall ready を全セクション ready とみなす（後方互換）
    const isSectionReady = (key) => (hasSections ? sections[key] === 'ready' : overallReady);

    this.updateMessageInConversation(conversationId, messageId, (msg) => {
      const prevSections = msg.webSections || {};
      let items = Array.isArray(msg.items) ? msg.items : [];
      let webCandidates = msg.webCandidates;
      let roleGapCandidates = msg.roleGapCandidates;

      // enriched_items: ready になったら items を id で突き合わせ置換
      if (isSectionReady('enriched_items')) {
        const enriched = Array.isArray(data.enriched_items) ? data.enriched_items : [];
        if (enriched.length > 0) {
          const byId = {};
          enriched.forEach(e => { if (e && e.id !== undefined && e.id !== null) byId[String(e.id)] = e; });
          items = items.map(it => (it && byId[String(it.id)]) ? byId[String(it.id)] : it);
        }
      }
      // web_candidates: ready になったら反映
      if (isSectionReady('web_candidates')) {
        webCandidates = Array.isArray(data.web_candidates) ? data.web_candidates : [];
      }
      // role_gap_candidates: ready になったら反映
      if (isSectionReady('role_gap_candidates')) {
        roleGapCandidates = Array.isArray(data.role_gap_candidates) ? data.role_gap_candidates : [];
      }

      // セクションごとの表示状態を更新（ready/pending/failed/timeout）。ready は一度確定したら不変。
      //  - overallReady のときは、未readyのセクションも「完了(0件は空状態)」として ready 扱いにする
      //  - failed(ジョブ失敗)のときだけ、未完了セクションを failed（オレンジのエラー）にする
      //  - タイムアウトは timeout（中立表示）にする
      const webSections = {};
      this.WEB_RESULT_SECTIONS.forEach((key) => {
        if (prevSections[key] === 'ready' || isSectionReady(key) || overallReady) {
          webSections[key] = 'ready';
        } else if (jobFailed) {
          webSections[key] = 'failed';
        } else if (timedOut) {
          webSections[key] = 'timeout';
        } else {
          webSections[key] = 'pending';
        }
      });

      const stillPending = this.WEB_RESULT_SECTIONS.some(k => webSections[k] === 'pending');
      return {
        ...msg,
        items,
        webCandidates,
        roleGapCandidates,
        webSections,
        webCompletionPending: stillPending,
      };
    });
  };

  // AIレコメンドのWeb補完結果を web_job_token でポーリングし、セクションが ready になった順に反映する。
  pollWebResult = (conversationId, messageId, token, attempt) => {
    const POLL_INTERVAL_MS = 3000;   // 約3秒間隔
    const POLL_MAX_ATTEMPTS = 100;   // 上限100回（約5分）。role_gap等の重い補完に合わせて延長（BEジョブは600秒）

    this.props.getAiWebResult(token)
      .then((httpResponse) => {
        const data = httpResponse && httpResponse.data ? httpResponse.data : {};
        const overallReady = data.ready === true;
        const failed = data.failed === true;
        const timedOut = attempt + 1 >= POLL_MAX_ATTEMPTS;

        // 出来ているセクションを反映。failed=ジョブ失敗はエラー、overallReady/timeoutは完了扱い。
        this.applyWebResultSections(conversationId, messageId, data, { failed, timedOut });

        if (overallReady || failed || timedOut) return; // ポーリング停止

        this.webResultTimers.push(setTimeout(() => {
          this.pollWebResult(conversationId, messageId, token, attempt + 1);
        }, POLL_INTERVAL_MS));
      })
      .catch((error) => {
        // 400/404 等は継続不能なので停止し、残りセクションをfailed表示に。一時的な失敗は上限まで再試行。
        const HTTP_BAD_REQUEST = 400;
        const HTTP_NOT_FOUND = 404;
        const status = error && error.response && error.response.status;
        const isFatal = status === HTTP_BAD_REQUEST || status === HTTP_NOT_FOUND;
        if (isFatal || attempt + 1 >= POLL_MAX_ATTEMPTS) {
          // 400/404 等の継続不能はジョブ失敗扱い、その他の上限到達はタイムアウト扱い
          this.applyWebResultSections(conversationId, messageId, {}, { failed: isFatal, timedOut: !isFatal });
          return;
        }
        this.webResultTimers.push(setTimeout(() => {
          this.pollWebResult(conversationId, messageId, token, attempt + 1);
        }, POLL_INTERVAL_MS));
      });
  };

  componentWillMount() {
    // URLパラメータをチェックして特定のパラメータが存在する場合はフィルター値として適用
    const { filterParams } = this.extractUrlFilterParams();

    if (Object.keys(filterParams).length > 0) {
      // stateのfilterValueに直接設定
      this.setState({
        filterValue: { ...this.initialState.filterValue, ...filterParams }
      });
    }

    // URLパラメータが存在する場合は新しいfilterValueを使用、そうでなければ現在のstateを使用
    const currentFilterValue = Object.keys(filterParams).length > 0 ?
      { ...this.initialState.filterValue, ...filterParams } :
      this.state.filterValue;

    let query = this.filterValueToQuery(currentFilterValue);
    if (this.props.routerInfo && this.props.routerInfo.state && this.props.routerInfo.state.hasOwnProperty('query')) {
      let filter = this.props.routerInfo.state.hasOwnProperty('filter') ?
        this.props.routerInfo.state.filter : {};
      query = { ...query, ...filter, ...this.props.routerInfo.state.query }
    }

    this.handleFilterSelected(query);
    this.props.replace('/executive-list', {})

    this.props.getUserInfo();
    this.props.postIpCheck();
    this.props.getExecutiveListFilters();
    this.props.getIndustryCategoryList();
    this.props.postExecutiveListGetTags();
    this.props.getSalesforceConfig();
    this.props.getLetterOrderList({
      is_own: 'false',
      except_letter_order_addresses: 'true'
    });
    this.props.getFollowCallOrderList({
      is_own: 'false',
      is_exe: 'true',
      with_ownership_user: 'true',
    });
    this.props.getResearchedTelHasDepartments({
      get_at_from: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      get_at_to: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    })
  }

  extractUrlFilterParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const filterParams = {};

    // DAILY_NOTIFICATION_FILTER_CONFIGのキーを使用してパラメータをチェック
    Object.keys(DAILY_NOTIFICATION_FILTER_CONFIG).forEach(key => {
      if (urlParams.has(key)) {
        filterParams[key] = urlParams.get(key);
      }
    });

    // 検索結果とDailyNotificationDialogの内容が被ってしまうので非表示にする
    if (Object.keys(filterParams).length > 0) {
      this.setState({
        showDailyNotificationDialog: false
      })
    }

    return { filterParams };
  }

  componentDidMount() {
    this.setState({
      showPlanDialog: isPlanExpired(this.props.user)
    })

    // AIチャットの会話をlocalStorageから復元する（複数会話・過去チャット選択に対応）
    const restored = this.loadConversations();
    if (restored && restored.conversations.length > 0) {
      const current = restored.conversations.find(c => c.id === restored.currentConversationId) || restored.conversations[0];
      this.setState({
        conversations: restored.conversations,
        currentConversationId: current.id,
        chatMessages: Array.isArray(current.messages) ? current.messages : [],
        isInitialMessageShown: current.isInitialMessageShown === true,
      });
    }

    // キーマンデータベース（一覧・詳細ダイアログ）でのコピペを検知する
    document.addEventListener('copy', this.handleCopyDetection);
  }

  // AIチャット会話のlocalStorage保存キー
  aiConversationsStorageKey = 'posto_kdb_ai_conversations';
  // 旧: 単一会話の保存キー（マイグレーション用）
  aiChatStorageKey = 'posto_kdb_ai_chat';

  // 会話IDを生成する
  generateConversationId = () => {
    const RANDOM_RANGE = 100000;
    return `c-${Date.now()}-${Math.floor(Math.random() * RANDOM_RANGE)}`;
  };

  // 会話タイトルを最初のユーザー発言から生成する（無ければ「新しいチャット」）
  // セレクトボックスの幅で自然にクリップされるため、ここでは長めに保持する
  deriveConversationTitle = (messages) => {
    const TITLE_MAX = 100;
    const firstUser = Array.isArray(messages) ? messages.find(m => m.sender === 'user' && typeof m.text === 'string' && m.text.trim() !== '') : null;
    if (!firstUser) return '新しいチャット';
    const t = firstUser.text.trim().replace(/\s+/g, ' ');
    return t.length > TITLE_MAX ? `${t.slice(0, TITLE_MAX)}…` : t;
  }

  // localStorageから会話一覧を読み込む（旧形式があれば1会話としてマイグレーション）
  loadConversations = () => {
    try {
      const raw = window.localStorage.getItem(this.aiConversationsStorageKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && Array.isArray(parsed.conversations)) {
          return { conversations: parsed.conversations, currentConversationId: parsed.currentConversationId || null };
        }
      }
      // 旧形式(single chat)のマイグレーション
      const legacyRaw = window.localStorage.getItem(this.aiChatStorageKey);
      if (legacyRaw) {
        const legacy = JSON.parse(legacyRaw);
        if (legacy && Array.isArray(legacy.messages) && legacy.messages.length > 0) {
          const id = this.generateConversationId();
          return {
            conversations: [{
              id,
              title: this.deriveConversationTitle(legacy.messages),
              messages: legacy.messages,
              isInitialMessageShown: legacy.isInitialMessageShown === true,
              updatedAt: Date.now(),
            }],
            currentConversationId: id,
          };
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  // メッセージIDを生成する（同一ミリ秒での衝突を避けるため乱数を付与）
  generateMessageId = () => {
    const RANDOM_RANGE = 100000;
    return `m-${Date.now()}-${Math.floor(Math.random() * RANDOM_RANGE)}`;
  };

  // 現在の会話(chatMessages)をconversationsへ反映しlocalStorageへ保存する
  persistChat = () => {
    try {
      const currentId = this.state.currentConversationId;
      const messages = this.state.chatMessages;
      const hasCurrent = currentId && this.state.conversations.find(c => c.id === currentId);

      // 空の会話（メッセージ無し・未作成）は保存しない（全削除後の空状態を維持する）
      if (!hasCurrent && messages.length === 0) {
        return;
      }

      let conversations;
      let ensuredId = currentId;
      // 現在の会話に変化があるか（無ければ再レンダーは避けるが、localStorageへの保存は必ず行う）
      let currentChanged = true;
      if (!hasCurrent) {
        // 会話が無ければ作成する
        ensuredId = this.generateConversationId();
        conversations = [...this.state.conversations, {
          id: ensuredId,
          title: this.deriveConversationTitle(messages),
          messages,
          isInitialMessageShown: this.state.isInitialMessageShown,
          updatedAt: Date.now(),
        }];
      } else {
        const target = this.state.conversations.find(c => c.id === currentId);
        if (target && target.messages === messages && target.isInitialMessageShown === this.state.isInitialMessageShown) {
          // 現在の会話は無変更。ただし他の会話への追記が state に入っている可能性があるため保存はする。
          conversations = this.state.conversations;
          currentChanged = false;
        } else {
          conversations = this.state.conversations.map(c => c.id === currentId ? {
            ...c,
            title: this.deriveConversationTitle(messages),
            messages,
            isInitialMessageShown: this.state.isInitialMessageShown,
            updatedAt: Date.now(),
          } : c);
        }
      }

      // 無駄な再レンダーや並び順変更を防ぐため、変化があるときのみ setState する
      if (currentChanged && (ensuredId !== currentId || conversations !== this.state.conversations)) {
        this.setState({ conversations, currentConversationId: ensuredId });
      }
      window.localStorage.setItem(this.aiConversationsStorageKey, JSON.stringify({
        conversations,
        currentConversationId: ensuredId,
      }));
    } catch (e) {
      void e;
    }
  }

  // 送信時点で会話が確定していることを保証し、その会話IDを返す（無ければ作成）
  ensureCurrentConversation = () => {
    const currentId = this.state.currentConversationId;
    if (currentId && this.state.conversations.find(c => c.id === currentId)) {
      return currentId;
    }
    const id = this.generateConversationId();
    const conv = {
      id,
      title: this.deriveConversationTitle(this.state.chatMessages),
      messages: this.state.chatMessages,
      isInitialMessageShown: this.state.isInitialMessageShown,
      updatedAt: Date.now(),
    };
    this.setState(prev => ({ conversations: [...prev.conversations, conv], currentConversationId: id }));
    return id;
  };

  // 指定した会話にメッセージを追記する（非同期応答が別会話へ混入しないように会話を特定）。
  // 対象が現在の会話なら chatMessages に、別会話なら conversations の該当会話に反映する。
  // extraState（isChatLoading/showChatDrawer 等のUI状態）は、対象が現在の会話のときだけ適用する
  // （応答待ち中に別会話へ切り替えた場合、現在表示中の会話のUIを汚さないため）。
  appendMessageToConversation = (conversationId, message, extraState = {}) => {
    this.setState(prev => {
      if (prev.currentConversationId === conversationId) {
        return { ...extraState, chatMessages: [...prev.chatMessages, message] };
      }
      const conversations = prev.conversations.map(c => c.id === conversationId
        ? { ...c, messages: [...(Array.isArray(c.messages) ? c.messages : []), message], updatedAt: Date.now() }
        : c);
      return { conversations };
    }, () => {
      this.persistChat();
    });
  };

  // 新しいチャットを開始する（現在の会話は保存済み。空の会話に切り替える）
  handleNewChat = () => {
    const newId = this.generateConversationId();
    const newConversation = {
      id: newId,
      title: '新しいチャット',
      messages: [],
      isInitialMessageShown: false,
      updatedAt: Date.now(),
    };
    this.setState(prevState => ({
      conversations: [...prevState.conversations, newConversation],
      currentConversationId: newId,
      chatMessages: [],
      isInitialMessageShown: false,
      isChatLoading: false,
    }), () => {
      // 初期メッセージ（挨拶）を表示する
      this.showChatInitialMessage();
    });
  }

  // 過去の会話に切り替える
  handleSelectConversation = (conversationId) => {
    const target = this.state.conversations.find(c => c.id === conversationId);
    if (!target) return;
    this.setState({
      currentConversationId: conversationId,
      chatMessages: Array.isArray(target.messages) ? target.messages : [],
      isInitialMessageShown: target.isInitialMessageShown === true,
      isChatLoading: false,
    });
  }

  // 現在の会話を削除する。削除後は残りの最新会話に切り替える（無ければ空の新規会話）。
  // 指定した会話を削除する（引数が無ければ現在の会話を削除）。
  handleDeleteConversation = (conversationId) => {
    const targetId = conversationId || this.state.currentConversationId;
    const remaining = this.state.conversations.filter(c => c.id !== targetId);

    // 削除対象が現在表示中でない場合は、表示中の会話をそのまま維持する
    if (targetId !== this.state.currentConversationId && this.state.currentConversationId) {
      this.setState({ conversations: remaining }, () => {
        this.saveConversationsToStorage(remaining, this.state.currentConversationId);
      });
      return;
    }

    if (remaining.length > 0) {
      // 更新日時が最新の会話へ切り替える
      const next = remaining.slice().sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))[0];
      this.setState({
        conversations: remaining,
        currentConversationId: next.id,
        chatMessages: Array.isArray(next.messages) ? next.messages : [],
        isInitialMessageShown: next.isInitialMessageShown === true,
        isChatLoading: false,
      }, () => {
        this.saveConversationsToStorage(remaining, next.id);
      });
    } else {
      // 会話が無くなったら空の状態にし、localStorageもクリアする
      this.setState({
        conversations: [],
        currentConversationId: null,
        chatMessages: [],
        isInitialMessageShown: false,
        isChatLoading: false,
      }, () => {
        this.saveConversationsToStorage([], null);
        // 挨拶メッセージを表示する
        this.showChatInitialMessage();
      });
    }
  }

  // conversations/currentConversationId をlocalStorageへ保存する（削除時などの明示保存用）
  saveConversationsToStorage = (conversations, currentConversationId) => {
    try {
      window.localStorage.setItem(this.aiConversationsStorageKey, JSON.stringify({
        conversations,
        currentConversationId,
      }));
    } catch (e) {
      void e;
    }
  }

  // 初期メッセージ（挨拶）を表示する（未表示の場合のみ）
  // 初期メッセージ表示用のタイマーID（アンマウント時にクリアするため保持）
  initialMessageTimers = [];

  showChatInitialMessage = () => {
    if (this.state.isInitialMessageShown) return;
    const INITIAL_MESSAGE_DELAY = 800;
    const LOADING_START_DELAY = 100;
    this.initialMessageTimers.push(setTimeout(() => {
      this.setState({ isChatLoading: true });
    }, LOADING_START_DELAY));
    this.initialMessageTimers.push(setTimeout(() => {
      // 800ms待つ間に多重スケジュールされる可能性があるため、発火時にも重複防止チェックする
      if (this.state.isInitialMessageShown) return;
      const initialMessage = {
        id: this.generateMessageId(),
        text: 'Keyman Database AIがお手伝いします！\n・探したいキーマンの条件や商材を教えてください（例:「東京のSaaS企業の人事部長」）\n・このアカウントの稼働状況も確認できます（例:「今何件コールしてる？」「商談日時が未確定の企業は？」）',
        sender: 'bot',
        timestamp: new Date()
      };
      this.setState(prevState => ({
        chatMessages: [...prevState.chatMessages, initialMessage],
        isInitialMessageShown: true,
        isChatLoading: false
      }));
    }, INITIAL_MESSAGE_DELAY));
  }

  // コピペを検知し、回数をカウント・ログ送信し、上限超過時はアラートを表示する
  handleCopyDetection = (e) => {
    // 選択中のテキストを取得（テキストが無いコピーは検知対象外）
    const selectedText = window.getSelection ? window.getSelection().toString() : '';
    if (!selectedText || selectedText.trim() === '') {
      return;
    }

    // 検索ボックス等のフォーム入力からのコピーは対象外とする
    const tagName = e.target && e.target.tagName ? e.target.tagName : '';
    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
      return;
    }

    // ログインメールアドレスを識別子としてカウント（未取得時は空文字）
    const email = this.props.user && this.props.user.email ? this.props.user.email : '';
    const count = incrementTodayCopyCount(email);
    const isOverLimit = isCopyCountOverLimit(count);

    // 上限を超えた後は毎回APIを呼ばず、ログ記録を間引く。
    // ・「初めて上限を超えた瞬間」の1回は超過の事実を記録する。
    // ・それ以降はKEYMAN_COPY_LOG_INTERVAL_AFTER_LIMITの倍数の回数（50回, 100回...）でのみ記録する。
    const isFirstOverLimit = count === KEYMAN_COPY_DAILY_LIMIT + 1;
    const isLogInterval = count % KEYMAN_COPY_LOG_INTERVAL_AFTER_LIMIT === 0;
    if (!isOverLimit || isFirstOverLimit || isLogInterval) {
      // バックエンドにコピペログ（メールアドレス・日時・回数等）を記録する
      this.props.postExecutiveListCopyLog({
        email: email,
        copied_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        count: count,
        copied_length: selectedText.length,
        path: window.location.pathname,
      });
    }

    // 1日の上限回数を超えた場合は画面に警告を表示する
    if (isOverLimit) {
      this.displayNotification(
        `本日のコピー回数が上限（${KEYMAN_COPY_DAILY_LIMIT}回）を超えました。コピー操作はログイン情報・日時とともに記録・監視されています。`,
        'error',
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routerInfo && this.props.routerInfo.state && this.props.routerInfo.state.hasOwnProperty('item')) {
      if (this.props.routerInfo.state !== nextProps.routerInfo.state) {
        this.setState({
          showDailyNotificationDialog: false,
          item: this.props.routerInfo.state.item,
          filterValue: this.props.routerInfo.state.filterValue
        })
      }
    }
    if (this.props.match.params.id !== nextProps.match.params.id) {
      let query = this.filterValueToQuery(this.state.filterValue);
      this.props.postExecutiveListSearch({
        ...query,
        'page': this.props.pageInfo && this.props.pageInfo.current_page ? this.props.pageInfo.current_page : 1,
        'per_page': this.state.perPage,
        'paging': 1,
        'include_corporation_count': true
      }, true);
    }

    if (this.props.isLoading && !nextProps.isLoading && !this.state.isPageLoaded) {
      this.setState({
        isPageLoaded: true,
      })
    }

    if (nextProps.isLoading || nextProps.isLoadingExecutiveListItem) {
      document.body.style.cursor = "progress";
    } else {
      document.body.style.cursor = "auto";
    }

    if (nextProps.message && nextProps.message !== '') {
      this.displayNotification(nextProps.message, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if ((this.props.isDeletingTags && !nextProps.isDeletingTags) ||
      (this.props.isUpdatingTags && !nextProps.isUpdatingTags) ||
      (this.props.isLoadingCsv && !nextProps.isLoadingCsv)) {
      if (isNaN(nextProps.match.params.id)) {
        this.handleUpdateFilter(this.state.filterValue, false);
      }

      this.props.postExecutiveListGetTags();
    }

    this.setState({
      showInfoBox: nextProps.cookies.get('showInfoBox') === '0' ? false : nextProps.showInfoBox,
      showBanner: nextProps.cookies.get('showBanner') === '0' ? false : nextProps.showBanner,
    })

    if (this.props.user !== nextProps.user) {
      this.setState({
        showPlanDialog: isPlanExpired(this.props.user)
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasLetterOrderHistoryNames !== prevProps.hasLetterOrderHistoryNames ||
      this.props.duplicateNames !== prevProps.duplicateNames
    ) {
      if (
        this.props.hasLetterOrderHistoryNames.length ||
        this.props.duplicateNames.length
      ) {
        this.confirmSendLetterDialogSet(this.props.hasLetterOrderHistoryNames, this.props.duplicateNames)
      } else {
        this.goToSendLetter()
      }
    }

    if (this.state.item && this.state.item !== prevState.item && !this.state.showCsvDownloadDialog) {
      let query = this.selectionToQuery();
      // sort_typeがキーマンの並び替えとかぶってしまうので削除
      delete query['sort_type'];
      this.props.getExecutiveListById(this.state.item.id);
      this.setState({
        showExecDetailItemDialog: true
      })
    }

    if (
      prevProps.isPostingSalesforceSync === true &&
      !this.props.isPostingSalesforceSync
    ) {
      if (isNaN(this.props.match.params.id)) {
        this.handleUpdateFilter(this.state.filterValue);
      }
      this.props.postExecutiveListGetTags();
    }

    // 2023/12/14日の時点で下記の条件に当てはまることはない
    if (this.props.routerInfo !== prevProps.routerInfo) {
      let query = this.filterValueToQuery(this.initialState.filterValue);

      if (
        this.props.routerInfo &&
        this.props.routerInfo.state &&
        this.props.routerInfo.state.hasOwnProperty("query")
      ) {
        let filter = this.props.routerInfo.state.hasOwnProperty("filter")
          ? this.props.routerInfo.state.filter
          : {};
        query = { ...query, ...filter, ...this.props.routerInfo.state.query };
        this.handleFilterSelected(query);
        this.props.replace('/executive-list', {})
      }
    }

    if (!this.props.isLoading && this.props.isLoading !== prevProps.isLoading) {
      this.scrollToTop()
    }

    // AIチャット履歴が変わったらlocalStorageへ保存する
    if (
      prevState.chatMessages !== this.state.chatMessages ||
      prevState.isInitialMessageShown !== this.state.isInitialMessageShown
    ) {
      this.persistChat();
    }
  }

  componentWillUnmount() {
    this.props.clearExecutiveList()
    document.removeEventListener('copy', this.handleCopyDetection);
    // 初期メッセージ表示用のタイマーを解除（アンマウント後のsetStateを防ぐ）
    this.initialMessageTimers.forEach(t => clearTimeout(t));
    this.initialMessageTimers = [];
    // Web補完結果ポーリングのタイマーを解除
    this.webResultTimers.forEach(t => clearTimeout(t));
    this.webResultTimers = [];
  }

  /*** handler functions ***/
  handleSelectAll = (checked) => {
    this.setState({
      isSelectAll: checked,
      selectedItems: Set(),
      selectedItemsMap: Map(),
      unselectedItems: Set(),
      selectCount: checked ? this.props.pageInfo.total : 0,
    });
  }

  handleSelectItem = (item, key, checked) => {
    let { unselectedItems, selectedItems, selectedItemsMap, selectCount, isSelectAll, perPage } = this.state;

    let { pageInfo } = this.props;
    let checkedItem = false;
    if (isSelectAll) {
      // 全選択モード時の判定:
      // - key は「現在ページ内のインデックス」(0 始まり)
      // - currentPage/perPage を用いてリスト全体でのグローバルインデックスを算出
      //   globalIndex = (currentPage - 1) * perPage + key
      // - 先頭から selectCount 件が選択対象なので、globalIndex < selectCount で判定する
      // 例:
      //   perPage=50, current_page=3 -> ページ先頭(key=0)の globalIndex は (3-1)*50+0 = 100
      //   - selectCount=120 -> 100 < 120 なので対象
      //   - selectCount=100 -> 100 < 100 は偽なので非対象 (境界)
      //   - key=49 のとき globalIndex=149。selectCount=150 なら対象、149 なら非対象
      const currentPage = (pageInfo && pageInfo.current_page) ? pageInfo.current_page : 1;
      const globalIndex = (currentPage - 1) * perPage + key;
      checkedItem = globalIndex < selectCount;
    } else {
      checkedItem = key < selectCount;
    }

    if (checkedItem) {
      // 全選択モードの「対象行」をクリックした場合:
      // - チェックON  : 除外集合から削除(=選択として扱う)
      // - チェックOFF : 除外集合に追加(=全体選択から除外)
      if (checked) {
        unselectedItems = this.state.unselectedItems.delete(item.id);
      } else {
        unselectedItems = this.state.unselectedItems.add(item.id);
      }
    } else {
      // 通常モードの「非対象行」をクリックした場合:
      // - チェックON  : selectedItems/selectedItemsMap に追加
      // - チェックOFF : それぞれから削除
      if (checked) {
        selectedItems = this.state.selectedItems.add(item.id);
        selectedItemsMap = this.state.selectedItemsMap.set(item.id, item);
      } else {
        selectedItems = this.state.selectedItems.delete(item.id);
        selectedItemsMap = this.state.selectedItemsMap.delete(item.id);
      }
    }

    // 全体の実質的な選択件数 = selectCount(全選択の基数) - 除外件数 + 個別選択件数
    // -> これが 0 になったら全選択モードを解除してカウントをリセット
    if (this.state.selectCount - unselectedItems.count() + selectedItems.count() === 0) {
      this.setState({
        isSelectAll: false,
        selectCount: 0,
      })
    }

    this.setState({
      unselectedItems: unselectedItems,
      selectedItems: selectedItems,
      selectedItemsMap: selectedItemsMap,
    })
  }

  handleSetSelectOption = (state) => {
    if (state.selectCount > 0 && state.selectCount <= this.props.pageInfo.total) {
      this.setState({
        selectCount: state.selectCount,
        isSelectAll: true,
        selectedItems: Set(),
        selectedItemsMap: Map(),
        unselectedItems: Set(),
      });
    } else {
      this.setState({
        selectCount: 0,
        isSelectAll: false,
        selectedItems: Set(),
        selectedItemsMap: Map(),
        unselectedItems: Set(),
      });
    }
  }

  handleNestedMenuDelete = (filterValue, property, label, menu) => {
    let collection = filterValue[property];

    if (collection.has(label.toString())) {
      return collection.delete(label);
    }

    for (const menuItem of menu) {
      const submenuItem = (menuItem.submenu || []).find(item => item.value === label);
      if (submenuItem) {
        let submenu = collection.get(menuItem.value);
        if (!submenu) return collection;

        submenu = submenu.delete(label);
        return submenu.count() === 0
          ? collection.delete(menuItem.value)
          : collection.set(menuItem.value, submenu);
      }
    }

    return collection;
  };

  handleUpdateFilterWithState = (filterValue, state, selectFilter = false) => {
    if (!selectFilter) {
      this.setState({
        selectedFilter: "選択してください"
      })
    }

    this.setState({
      ...state,
      filterValue: { ...this.state.filterValue, ...filterValue },
      showNoMatchCorporationCsvExportPanel: (filterValue.company_name && filterValue.company_name.size > 0) || (filterValue.corporate_number && filterValue.corporate_number.size > 0), // 検索後に表示・非表示を決めるのでこのタイミングでフラグを更新
    }, () => {
      let query = this.filterValueToQuery(filterValue);
      query['paging'] = 1;
      query['per_page'] = state.hasOwnProperty('perPage') ? state['perPage'] : this.state.perPage;
      query['page'] = state['page'] ? state['page'] : 1;
      query['include_corporation_count'] = true;

      this.props.postExecutiveListSearch(query, true);
    })
  }

  scrollToTop = () => {
    if (this.addressTableContent) {
      this.addressTableContent.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  }

  handleUpdateFilter = (filterValue, selectFilter = false) => {
    let query = this.filterValueToQuery(filterValue);
    query['paging'] = 1;
    query['per_page'] = this.state.perPage;
    query['page'] = 1;
    query['include_corporation_count'] = true;

    if (filterValue) {
      if (filterValue.unique_per_corporation) {
        // 会社を一意にする場合、異動日順に固定する
        query['sort_type'] = ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value;
      }
    }

    if (!selectFilter) {
      this.setState({
        selectedFilter: "選択してください"
      })
    }

    this.setState({
      filterValue: { ...this.state.filterValue, ...filterValue },
      selectedItems: Set(),
      selectedItemsMap: Map(),
      unselectedItems: Set(),
      isSelectAll: false,
      selectCount: 0,
      sortType: query['sort_type'],
      showNoMatchCorporationCsvExportPanel: ((filterValue.company_name && filterValue.company_name.size > 0) || (filterValue.corporate_number && filterValue.corporate_number.size > 0)), // 検索後に表示・非表示を決めるのでこのタイミングでフラグを更新
    }, () => {
      this.props.postExecutiveListSearch(query, true);
    })
  }

  handleChipsDelete = (property, label) => {
    let filterValue = { ...this.state.filterValue };

    if (MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG && MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[property]) {
      const statusConfig = MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[property];
      let collection = filterValue[property];

      if (collection.has(label.toString())) {
        const statusItem = statusConfig.menu.find(item => item.value === label.toString());
        if (statusItem) {
          const statusName = statusItem.name;
          const clearFields = statusConfig.clearFields[statusName];
          if (clearFields) {
            clearFields.forEach(field => {
              filterValue[field] = '';
            });
          }
        }
        filterValue[property] = collection.delete(label);
      } else {
        filterValue[property] = this.handleNestedMenuDelete(
          filterValue,
          property,
          label,
          statusConfig.menu
        );
      }
    }

    if (MAP_MENU_CONFIG && MAP_MENU_CONFIG[property]) {
      filterValue[property] = this.handleNestedMenuDelete(
        filterValue,
        property,
        label,
        MAP_MENU_CONFIG[property].menu
      );
    }

    if (DAILY_NOTIFICATION_FILTER_CONFIG && DAILY_NOTIFICATION_FILTER_CONFIG[property]) {
      filterValue['exclude_retirement'] = this.initialState.filterValue.exclude_retirement;
      filterValue[property] = '';
    }

    if (KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG && KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG[property]) {
      filterValue[property] = this.initialState.filterValue[property];
    }

    if (USER_LIST_FILTER_CONFIG && USER_LIST_FILTER_CONFIG[property]) {
      filterValue[property] = filterValue[property].remove(label.toString());
    }

    if (HIERARCHICAL_MENU_CONFIG && HIERARCHICAL_MENU_CONFIG[property]) {
      // labelは配列で返ってくる
      label.forEach(item => {
        filterValue[property] = filterValue[property].delete(item);
      });
    }
    if (KEYWORD_SEARCH_CONFIG && KEYWORD_SEARCH_CONFIG[property]) {
      filterValue[property] = KEYWORD_SEARCH_CONFIG[property].initialValue;
      // キーワード用のAND/OR検索が存在する場合、キーワード用のAND/OR検索の初期値を設定する
      if (KEYWORD_SEARCH_IS_AND_CONFIG && KEYWORD_SEARCH_IS_AND_CONFIG[`is_and_search_${property}`]) {
        filterValue[`is_and_search_${property}`] = KEYWORD_SEARCH_IS_AND_CONFIG[`is_and_search_${property}`].initialValue;
      }
    }

    if (CORPORATION_RELATIONSHIPS_CONFIG && CORPORATION_RELATIONSHIPS_CONFIG[property]) {
      filterValue[property] = CORPORATION_RELATIONSHIPS_CONFIG[property].initialValue;
      // ライバルだけ昔から実装されていてプロパティーの命名規則が守れてないので別途処理
      if (CORPORATION_RELATIONSHIPS_LABEL_CONFIG && CORPORATION_RELATIONSHIPS_LABEL_CONFIG[`rival_label`]) {
        filterValue['rival_label'] = CORPORATION_RELATIONSHIPS_LABEL_CONFIG['rival_label'].initialValue;
      }
      if (CORPORATION_RELATIONSHIPS_LABEL_CONFIG && CORPORATION_RELATIONSHIPS_LABEL_CONFIG[`${property}_label`]) {
        filterValue[`${property}_label`] = CORPORATION_RELATIONSHIPS_LABEL_CONFIG[`${property}_label`].initialValue;
      }
    }

    if (SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG[property]) {
      filterValue[property] = filterValue[property].remove(label.toString());
      this.handleUpdateFilter(filterValue);
      return;
    }

    // 資金調達フィルター: Set型は1つずつ削除、それ以外は初期値にリセット
    if (FUNDRAISING_FILTER_CONFIG && FUNDRAISING_FILTER_CONFIG[property]) {
      const config = FUNDRAISING_FILTER_CONFIG[property];
      if (config.type === 'set') {
        filterValue[property] = filterValue[property].remove(label.toString());
      } else {
        filterValue[property] = config.initialValue;
      }
      this.handleUpdateFilter(filterValue);
      return;
    }

    // 業種検索モードフィルター: 初期値にリセット
    if (INDUSTRY_SEARCH_MODE_CONFIG && INDUSTRY_SEARCH_MODE_CONFIG[property]) {
      filterValue[property] = INDUSTRY_SEARCH_MODE_CONFIG[property].initialValue;
      this.handleUpdateFilter(filterValue);
      return;
    }

    switch (property) {
      case 'cap_size_per_corporation':
        filterValue['cap_size_per_corporation'] = '0';
        filterValue['cap_sort_first_preferred'] = '0';
        filterValue['cap_sort_second_preferred'] = '0';
        break;
      case 'cap_sort_first_preferred':
        filterValue['cap_sort_first_preferred'] = '0';
        filterValue['cap_sort_second_preferred'] = '0';
        break;
      case 'cap_sort_second_preferred':
        filterValue['cap_sort_second_preferred'] = '0';
        break;
      case 'exclude_registered_address':
      case 'unique_per_corporation':
      case 'show_recently_created':
      case 'exclude_retirement':
      case 'exclude_retirement_risk':
      case 'is_include_consolidated_search_number_of_employees':
      case 'exists_corporation_department_tels_filter':
      case 'include_field_call_analysis_ids':
        filterValue[property] = this.initialState.filterValue[property];
        break;
      case 'relocation_at': {
        const yearDigit = 4;
        const monthDigit = 2;
        if (label.length === yearDigit || label === 'before2020') {
          filterValue[property] = filterValue[property].delete(label);
        } else if (label.length === (yearDigit + monthDigit)) {
          let year = label.substring(0, yearDigit);
          let month = label.substring(yearDigit, (yearDigit + monthDigit));

          let relocation_at = filterValue[property];
          let months = relocation_at.get(year);
          months = months.delete(month);
          if (months.count() === 0) {
            filterValue[property] = relocation_at.delete(year);
          } else {
            filterValue[property] = relocation_at.set(year, months);
          }
        }
        break;
      }
      case 'companys':
        filterValue['corporate_number'] = OrderedSet();
        filterValue['company_name'] = OrderedSet();
        break;
      default:
        break;
    }

    this.handleUpdateFilter(filterValue);
  }

  handleFilterSelected = (value) => {
    let filter, state;
    if (typeof value === 'object') {
      filter = {};
      state = {};
      filter['filter'] = value;

      if (value.hasOwnProperty('except_relocation_personnel_ids')) {
        state['unselectedItems'] = Set(value['except_relocation_personnel_ids']);
        state['isSelectAll'] = true;
      }

      if (value.hasOwnProperty('relocation_personnel_ids')) {
        state['selectedItems'] = Set(value['relocation_personnel_ids']);
        // selectedItemsMapはページ遷移を検討すると追加できません。
      }

      if (value.hasOwnProperty('select_count')) {
        state['selectCount'] = parseInt(value['select_count'], 10);
      }

      if (value.hasOwnProperty('sort_type')) {
        state['sortType'] = value['sort_type'];
      }

      if (value.hasOwnProperty('perPage')) {
        state['perPage'] = value['perPage'];
      }

      if (value.hasOwnProperty('page')) {
        state['page'] = value['page'];
      }
    } else {
      filter = this.props.filters.find(filter => filter.id.toString() === value);
    }

    if (filter) {
      let filterValue = { ...this.initialState.filterValue };
      let sortType = ''

      const yearDigit = 4;
      const monthDigit = 2;
      for (let key in filter.filter) {
        if ((MAP_MENU_CONFIG && MAP_MENU_CONFIG[key]) || (MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG && MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[key])) {
          filterValue[key] = convertFilterValuesToNestedMap(filter.filter[key], MAP_MENU_CONFIG[key] || MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[key]);
          continue;
        }

        if (DAILY_NOTIFICATION_FILTER_CONFIG && DAILY_NOTIFICATION_FILTER_CONFIG[key]) {
          filterValue[key] = filter.filter[key];
          continue;
        }

        if (KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG && KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG[key]) {
          filterValue[key] = filter.filter[key].toString() === 'true';
          continue;
        }

        if (HIERARCHICAL_MENU_CONFIG && HIERARCHICAL_MENU_CONFIG[key]) {
          filterValue[key] = Set(filter.filter[key]);
          continue;
        }

        if (KEYWORD_SEARCH_CONFIG && KEYWORD_SEARCH_CONFIG[key]) {
          filterValue[key] = filter.filter[key];
          continue;
        }

        if (KEYWORD_SEARCH_IS_AND_CONFIG && KEYWORD_SEARCH_IS_AND_CONFIG[key]) {
          filterValue[key] = filter.filter[key].toString() === 'true';
          continue;
        }

        if (CORPORATION_RELATIONSHIPS_CONFIG && CORPORATION_RELATIONSHIPS_CONFIG[key]) {
          filterValue[key] = Set(filter.filter[key]);
          continue;
        }

        if (CORPORATION_RELATIONSHIPS_LABEL_CONFIG && CORPORATION_RELATIONSHIPS_LABEL_CONFIG[key]) {
          filterValue[key] = filter.filter[key];
          continue;
        }

        if (SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG[key]) {
          filterValue[key] = Set(filter.filter[key]);
          continue;
        }

        if (INDUSTRY_SEARCH_MODE_CONFIG && INDUSTRY_SEARCH_MODE_CONFIG[key]) {
          filterValue[key] = filter.filter[key];
          continue;
        }

        if (FUNDRAISING_FILTER_CONFIG && FUNDRAISING_FILTER_CONFIG[key]) {
          // 資金調達フィルター: typeに応じてfilterValueへ復元（filterValueToQueryの逆変換）
          const fundraisingConfig = FUNDRAISING_FILTER_CONFIG[key];
          if (fundraisingConfig.type === 'set') {
            filterValue[key] = Set(filter.filter[key]);
          } else if (fundraisingConfig.type === 'boolean') {
            filterValue[key] = filter.filter[key].toString() === 'true';
          } else {
            // type === 'select'（文字列）
            filterValue[key] = filter.filter[key];
          }
          continue;
        }

        switch (key) {
          case 'cap_size_per_corporation':
          case 'cap_sort_first_preferred':
          case 'cap_sort_second_preferred':
          case 'sent_only_from':
          case 'sent_only_to':
          case 'sent_except_from':
          case 'sent_except_to':
          case 'corporation_sent_only_from':
          case 'corporation_sent_only_to':
          case 'corporation_sent_except_from':
          case 'corporation_sent_except_to':
          case 'follow_call_order_only_from':
          case 'follow_call_order_only_to':
          case 'follow_call_order_except_from':
          case 'follow_call_order_except_to':
            filterValue[key] = filter.filter[key];
            break;
          case 'sort_type':
            sortType = filter.filter[key];
            break;
          case 'unique_per_corporation':
            filterValue[key] = !!filter.filter[key];
            break;
          case 'created_at_from': {
            const today = moment();
            if (today.diff(moment(filter.filter['created_at_from']), 'days') === 1) {
              filterValue['show_yesterday_created'] = true;
            } else {
              filterValue['show_recently_created'] = true;
            }
            break;
          }
          case 'exclude_registered_address':
          case 'exclude_retirement_risk':
          case 'is_include_consolidated_search_number_of_employees':
          case 'exists_corporation_department_tels_filter':
          case 'include_field_call_analysis_ids':
            filterValue[key] = filter.filter[key].toString() === 'true';
            break;
          case 'exclude_retirement':
            filterValue[key] = filter.filter[key].toString();
            break;
          case 'corporate_number':
          case 'company_name':
          case 'tag':
          case 'exclude_list':
            filterValue[key] = Set(filter.filter[key]);
            break;
          case 'relocation_at': {
            let relocation_at = Map();
            filter.filter[key].forEach(date => {
              let year = date.substring(0, yearDigit);
              let months = relocation_at.has(year) ? relocation_at.get(year) : Set();
              if (date === "before2020") {
                relocation_at = relocation_at.set(date, months);
              } else {
                relocation_at = relocation_at.set(year, months.add(date.substring(yearDigit, (yearDigit + monthDigit))));
              }
            })
            filterValue[key] = relocation_at;
            break;
          }
          case 'jsic_s': { // jsic_lはjsic_sでカバーしているのでパラメータにはあるが不要
            filterValue['jsic'] = convertFilterValuesToNestedMap(filter.filter[key], MAP_MENU_CONFIG['jsic']);
            break;
          }
          default:
            break;
        }
      }

      if (state) {
        this.handleUpdateFilterWithState(filterValue, state, false);
      } else {
        // 保存した検索条件にソート順が含まれている場合stateをセットする
        if (sortType !== '') {
          this.setState({
            sortType: sortType
          }, () => this.handleUpdateFilter(filterValue, true));
        } else {
          this.handleUpdateFilter(filterValue, true);
        }
      }
    }

    if (typeof value !== 'object') {
      this.setState({
        selectedFilter: value,
      })
    }
  }

  handleCsvExportAll = () => {
    let query = this.filterValueToQuery(this.state.filterValue);

    if (this.state.isSelectAll) {
      query = {
        ...query,
        'except_relocation_personnel_ids': this.state.unselectedItems.toArray(),
        'relocation_personnel_ids': this.state.selectedItems.toArray(),
        'select_count': this.state.selectCount,
      }
    } else {
      query = {
        ...query,
        'relocation_personnel_ids': this.state.selectedItems.toArray(),
      }
    }

    this.props.postExecutiveListCsv(query);
  }

  handleCsvExportOne = (id) => {
    this.props.postExecutiveListCsv({ 'relocation_personnel_ids': [id] });
  }

  handleChangeListSetting = (sortType, perPage) => {
    if (sortType !== this.state.sortType || perPage !== this.state.perPage) {
      // ホット順以外に変更された場合はhot_score_tag_nameをクリア
      const newState = {
        perPage: perPage,
        sortType: sortType
      };
      if (sortType !== ExecSortType.SORT_TYPE_HOT_SCORE_ASC.value) {
        newState.hotScoreTagName = null;
      }
      this.setState(newState, () => this.handleUpdateFilter(this.state.filterValue, false));
    }
  }

  handleUpdateTags = (tags, type = TagType.CUSTOM_TAG) => {
    let query = this.selectionToQuery();
    query['tags'] = tags;
    query['type'] = type;

    this.props.postExecutiveListUpdateTag(query);
  }

  handleSalesforceSync = () => {
    let query = this.selectionToQuery();

    this.props.postExecutiveListSalesforceSync(query);
  }

  /*** toggle functions ***/
  toggleSaveFilterDialog = () => {
    this.setState({ showSaveFilterDialog: !this.state.showSaveFilterDialog });
  }

  toggleEditFilterDialog = () => {
    this.setState({ showEditFilterDialog: !this.state.showEditFilterDialog });
  }

  toggleInfoBox = () => {
    this.props.setShowInfoBox(!this.props.showInfoBox);
  }

  toggleBanner = () => {
    this.props.setShowBanner(!this.props.showBanner);
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  toggleExecDetailItemDialog = (item = null) => {
    this.setState({
      showExecDetailItemDialog: !this.state.showExecDetailItemDialog,
      item: item && item.id ? item : null,
    });
  }

  toggleSelectOptionDialog = () => {
    this.setState({ showSelectOptionDialog: !this.state.showSelectOptionDialog });
  }

  togglePlanDialog = () => {
    this.setState({ showPlanDialog: !this.state.showPlanDialog });
  }

  toggleManageTagsDialog = () => {
    this.setState({ showManageTagsDialog: !this.state.showManageTagsDialog });
  }

  toggleAttackListGeneratorDialog = () => {
    this.setState({ showAttackListGeneratorDialog: !this.state.showAttackListGeneratorDialog });
  }

  toggleEditTagsDialog = (item = null) => {
    this.setState({
      showEditTagsDialog: !this.state.showEditTagsDialog,
      item: item && item.id ? item : null,
    });
  }

  toggleCreateListDialog = (item = null, overrideQuery = null) => {
    this.setState({
      showCreateListDialog: !this.state.showCreateListDialog,
      item: item && item.id ? item : null,
      createListOverrideQuery: overrideQuery || null,
    });
  }

  toggleCsvDownloadDialog = (item = null) => {

    if (!this.state.showCsvDownloadDialog) {
      let query = this.filterValueToQuery(this.state.filterValue);
      if (item) {
        query['relocation_personnel_ids'] = [item.id];
      } else {
        if (this.state.isSelectAll) {
          query['except_relocation_personnel_ids'] = this.state.unselectedItems.toArray();
          query['select_count'] = this.state.selectCount;
        }
        query['relocation_personnel_ids'] = this.state.selectedItems.toArray();
      }

      this.props.getExportedList(query);
    }

    this.setState({
      showCsvDownloadDialog: !this.state.showCsvDownloadDialog,
      item: item && item.id ? item : null,
    });
  }

  toggleListSettingDialog = () => {
    this.setState({ showListSettingDialog: !this.state.showListSettingDialog });
  }

  togglePromotePlanChangeDialog = (type) => {
    this.setState({ [type["flag"]]: !(this.state[type["flag"]]) });
  }

  toggleSalesforceSyncWarningDialog = () => {
    this.setState({
      showSalesforceSyncWarningDialog: !this.state.showSalesforceSyncWarningDialog
    });
  }

  toggleConfirmSendDialog = () => {
    this.setState({ showConfirmSendDialog: !this.state.showConfirmSendDialog });
  }

  toggleDailyNotificationDialog = () => {
    this.setState({ showDailyNotificationDialog: !this.state.showDailyNotificationDialog });
  }


  toggleExportCountNotice = () => {
    this.setState({ showExportCountNotice: !this.state.showExportCountNotice });
  }

  disableExecutiveList = () => {
    const { user } = this.props;
    return !isEnabledDisplayExecutiveList(user) || isPlanExpired(user);
  }

  disablePagination = () => {
    const { user } = this.props;
    return isFreePlan(user) || this.disableExecutiveList();
  }

  disableSidebar = (props) => {
    return props.isLoading || props.isLoadingFilter || props.isLoadingExecutiveListItem || this.disableExecutiveList();
  }

  getSelectedCount = () => {
    if (this.state.isSelectAll) {
      return this.state.selectCount - this.state.unselectedItems.count() + this.state.selectedItems.count();
    } else {
      return this.state.selectedItems.count();
    }
  }

  getSelectedItemIds = () => (count = 1) => {
    let items = [];

    if (this.state.item) {
      return [this.state.item["id"]];
    } else {
      const { executiveList, pageInfo } = this.props;

      let total = pageInfo && pageInfo.total ? pageInfo.total : this.getSelectedCount();

      if (this.state.isSelectAll) {
        for (let i = 0; i < total; i++) {
          if (!this.state.unselectedItems.has(executiveList[i].id)) {
            items.push(executiveList[i]["id"]);
          }

          if (items.length === count) {
            break;
          }
        }
      } else {
        // this.state.selectedItemsは選択中のidのグループで、配列にした後に最初の1つをpushしている
        items.push(this.state.selectedItems.toArray()[0]);
      }
    }

    return items;
  }

  filterValueToQuery = (filterValue = this.state.filterValue) => {
    let data = {};
    // 初期値の差分を出す
    const diff = difference(filterValue, this.initialState.filterValue);

    // 「注文済み（日付指定）」 「フォローコール依頼済み（日付指定）」、「ダウンロード済み」は差分としない
    delete diff["sent_status"];
    delete diff["corporation_sent_status"];
    delete diff["follow_call_order_status"];
    delete diff["download_status"];
    delete diff["sent_only_from"];
    delete diff["sent_only_to"];
    delete diff["sent_except_from"];
    delete diff["sent_except_to"];
    delete diff["corporation_sent_only_from"];
    delete diff["corporation_sent_only_to"];
    delete diff["corporation_sent_except_from"];
    delete diff["corporation_sent_except_to"];
    delete diff["follow_call_order_only_from"];
    delete diff["follow_call_order_only_to"];
    delete diff["follow_call_order_except_from"];
    delete diff["follow_call_order_except_to"];

    // 「退任した人を含める」場合、は差分としない 退任した人を含めると"true,false"という値になるので、下記はこのままで良い
    if (diff["exclude_retirement"] === "true,false") {
      delete diff["exclude_retirement"];
    }

    // 差分があるとみなされれば、古いKeymanは表示しないようにフラグを立てる
    if (Object.keys(diff).length !== 0) {
      data['except_old_keyman'] = "true";
    }

    for (let property in filterValue) {
      // LaravelのConvertEmptyStringsToNull Middleware で空文字はnullとして変換されるので、
      // 初期値が空文字であるものについては "" の場合でないクエリの対象とする
      if (
        (KEYWORD_SEARCH_CONFIG && KEYWORD_SEARCH_CONFIG[property]) ||
        (CORPORATION_RELATIONSHIPS_LABEL_CONFIG && CORPORATION_RELATIONSHIPS_LABEL_CONFIG[property]) ||
        property === 'sent_only_from' ||
        property === 'sent_only_to' ||
        property === 'sent_except_from' ||
        property === 'sent_except_to' ||
        property === 'corporation_sent_only_from' ||
        property === 'corporation_sent_only_to' ||
        property === 'corporation_sent_except_from' ||
        property === 'corporation_sent_except_to' ||
        property === 'follow_call_order_only_from' ||
        property === 'follow_call_order_only_to' ||
        property === 'follow_call_order_except_from' ||
        property === 'follow_call_order_except_to'
      ) {
        if ((filterValue[property] !== '')) {
          data[property] = filterValue[property];
        }
      } else if (
        (DAILY_NOTIFICATION_FILTER_CONFIG && DAILY_NOTIFICATION_FILTER_CONFIG[property]) ||
        property === 'exclude_registered_address' ||
        property === 'exclude_retirement_risk' ||
        property === 'exists_corporation_department_tels_filter' ||
        property === 'include_field_call_analysis_ids'
      ) {
        if (filterValue && filterValue[property]) {
          data[property] = 'true';
        }
      } else if (FUNDRAISING_FILTER_CONFIG && FUNDRAISING_FILTER_CONFIG[property]) {
        // 資金調達フィルター: typeに応じてクエリ変換
        const config = FUNDRAISING_FILTER_CONFIG[property];
        const val = filterValue[property];
        if (config.type === 'boolean' && val) {
          data[property] = 'true';
        } else if (config.type === 'select' && val) {
          data[property] = val;
        } else if (config.type === 'set' && val && val.size > 0) {
          data[property] = val.toArray();
        }
      } else if (property === 'show_yesterday_created') {
        if (filterValue && filterValue[property]) {
          data['created_at_from'] = moment().subtract(1, 'day').format('YYYY-MM-DD');
        }
      } else if (property === 'show_recently_created') {
        if (filterValue && filterValue[property]) {
          const dayCountAtWeek = 7;
          data['created_at_from'] = moment().subtract(dayCountAtWeek, "day").format('YYYY-MM-DD');
        }
      } else if (
        property === 'is_include_consolidated_search_number_of_employees' ||
        (KEYWORD_SEARCH_IS_AND_CONFIG && KEYWORD_SEARCH_IS_AND_CONFIG[property])
      ) {
        data[property] = filterValue[property].toString();
      } else if (KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG && KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG[property]) {
        if (filterValue && filterValue[property]) {
          data[property] = filterValue[property].toString();
        }
      } else if (property === 'unique_per_corporation') {
        if (filterValue && filterValue[property]) {
          data['unique_per_corporation'] = 1;
        }
      } else if (property === 'exclude_retirement') {
        if (filterValue[property] === [true, false].toString()) { // 退任した人を含める
          data[property] = [true, false];
        } else if (filterValue[property] === [false].toString()) { //退任した人のみ表示
          data[property] = [false];
        } else {
          data[property] = [true];
        }
      } else if (property === 'relocation_at') {
        if (filterValue[property].count() > 0) {
          let param = [];
          let years = filterValue[property].keySeq().toArray();

          years.forEach(y => {
            if (filterValue[property].has(y) && filterValue[property].get(y).count() > 0) {
              let months = filterValue[property].get(y).toArray();
              months.forEach(m => {
                param.push(y + m);
              })
            } else {
              param.push(y);
            }
          })

          data[`${property}`] = param;
        }
      } else if (property === 'jsic') { // jsicの特別な処理なのでMAP_MENU_CONFIGより先に処理
        // TODO この処理でjsicをlとsに分岐させていてさまざまなところで影響が出ていて共通化しにくい。修正するにはバックエンドも含めて見直しをする
        let keys = filterValue[property].keySeq().toArray();
        let jsic_s = [], jsic_l = [];

        keys.forEach(key => {
          if (filterValue[property].has(key) && filterValue[property].get(key).count() > 0) {
            let menuItem = jsicMenu.find(m => m.value === key);

            if (menuItem && filterValue[property].get(key).count() === menuItem.submenu.length) {
              jsic_l.push(key);
            }

            let submenu = filterValue[property].get(key).toArray();
            submenu.forEach(item => {
              jsic_s.push(item)
            })
          }
        })

        if (jsic_l.length > 0) {
          data['jsic_l'] = jsic_l;
        }

        if (jsic_s.length > 0) {
          data['jsic_s'] = jsic_s;
        }
      } else if ((MAP_MENU_CONFIG && MAP_MENU_CONFIG[property]) || (MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG && MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[property])) {
        if (filterValue[property].count() > 0) {
          let param = flattenMap(filterValue[property]);
          if (param.length > 0) {
            data[property] = param;
          }
        }
      } else if (HIERARCHICAL_MENU_CONFIG && HIERARCHICAL_MENU_CONFIG[property]) {
        if (filterValue[property].size > 0) {
          data[property] = filterValue[property].toArray();
        }
      } else if (INDUSTRY_SEARCH_MODE_CONFIG && INDUSTRY_SEARCH_MODE_CONFIG[property]) {
        // 業種検索モード: initialValue以外の場合のみ送信
        const config = INDUSTRY_SEARCH_MODE_CONFIG[property];
        if (filterValue && filterValue[property] && filterValue[property] !== config.initialValue) {
          data[property] = filterValue[property];
        }
      } else if (property === 'cap_size_per_corporation' || property === 'cap_sort_first_preferred' || property === 'cap_sort_second_preferred') {
        data[`${property}`] = filterValue[property];
      } else {
        if (filterValue[property].count() > 0) {
          data[`${property}`] = filterValue[property].toArray();
        }
      }
    }

    data['sort_type'] = this.state.sortType;

    // ホット順ソートの場合、hot_score_tag_nameを追加
    if (this.state.sortType === ExecSortType.SORT_TYPE_HOT_SCORE_ASC.value) {
      let aiTagName = this.state.hotScoreTagName || this.getSelectedAiTagName();
      // stateから取得できない場合、data['tag']からフォールバック（タグが1つの場合）
      const tagArray = data && data['tag'];
      if (!aiTagName && tagArray && tagArray.length === 1 && tagArray[0].startsWith('AI生成_')) {
        aiTagName = tagArray[0];
      }
      if (aiTagName) {
        data['hot_score_tag_name'] = aiTagName;
      }
    }

    return data;
  }

  queryToNoMatchCorporationQuery = (query) => {
    // クエリをそのままコピーする
    let noMatchCorporationQuery = { ...query };

    // 不要なパラメータは削除する
    delete noMatchCorporationQuery['paging'];
    delete noMatchCorporationQuery['per_page'];
    delete noMatchCorporationQuery['page'];
    delete noMatchCorporationQuery['include_corporation_count'];

    // 会社をユニークとして検索させる
    noMatchCorporationQuery['unique_per_corporation'] = 1;

    return noMatchCorporationQuery;
  }

  selectionToQuery = () => {
    let query = this.filterValueToQuery(this.state.filterValue);

    if (this.state.item) {
      query['relocation_personnel_ids'] = [this.state.item.id];
    } else {
      if (this.state.isSelectAll) {
        query['except_relocation_personnel_ids'] = this.state.unselectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      }
      query['relocation_personnel_ids'] = this.state.selectedItems.toArray();
    }

    return query;
  }

  clearFilterValues = () => {
    let filterValue = this.initialState.filterValue;

    if (this.state.sortType !== ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value) {
      this.setState({
        sortType: ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value
      }, () => this.handleUpdateFilter(filterValue));
    } else {
      this.handleUpdateFilter(filterValue);
    }

    this.setState({
      filterValue: filterValue,
    })
  }

  filterValueToLabels = () => {
    let { filterValue } = this.state;
    let labels = [];
    let isSearchCompanys = false;

    for (let property in filterValue) {
      let label;

      if (
        property === 'show_yesterday_created' ||
        property === 'is_include_consolidated_search_number_of_employees' ||
        (KEYWORD_SEARCH_IS_AND_CONFIG && KEYWORD_SEARCH_IS_AND_CONFIG[property]) ||
        (CORPORATION_RELATIONSHIPS_LABEL_CONFIG && CORPORATION_RELATIONSHIPS_LABEL_CONFIG[property])
      ) {
        continue;
      }

      if (DAILY_NOTIFICATION_FILTER_CONFIG && DAILY_NOTIFICATION_FILTER_CONFIG[property]) {
        if (filterValue[property] !== '') {
          labels.push({ name: "本日" + DAILY_NOTIFICATION_FILTER_CONFIG[property].label, value: filterValue[property], property: property })
        }
        continue;
      }

      if (KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG && KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG[property]) {
        if (filterValue[property] !== this.initialState.filterValue[property]) {
          labels.push({ name: KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG[property].label, value: filterValue[property], property: property })
        }
        continue;
      }

      if (USER_LIST_FILTER_CONFIG && USER_LIST_FILTER_CONFIG[property]) {
        if (filterValue[property].count() > 0) {
          const tags = filterValue[property].toArray();
          tags.forEach(tag => labels.push({ name: USER_LIST_FILTER_CONFIG[property].label + ': ' + tag, category: USER_LIST_FILTER_CONFIG[property].category, value: tag, property: property }))
        }
        continue;
      }

      if (HIERARCHICAL_MENU_CONFIG && HIERARCHICAL_MENU_CONFIG[property]) {
        const selectedItems = compressSelectionToNodes(this.props[HIERARCHICAL_MENU_CONFIG[property].menuListKey], filterValue[property]);
        if (selectedItems.length > 0) {
          selectedItems.forEach(tag => labels.push({ name: HIERARCHICAL_MENU_CONFIG[property].labelFormatter(tag.name), category: HIERARCHICAL_MENU_CONFIG[property].category, value: getAllLeafIds(tag), property: property }))
        }
        continue;
      }

      if (property === 'company_name' || property === 'corporate_number') {
        if (filterValue[property].count() > 0) {
          isSearchCompanys = true;
        }
        continue;
      }

      if (CORPORATION_RELATIONSHIPS_CONFIG && CORPORATION_RELATIONSHIPS_CONFIG[property]) {
        if (filterValue[property].count() > 0) {
          // corporation_id(ライバルの企業)だけ昔から実装されていてプロパティーの命名規則が守れてないので別途処理
          if (property === 'corporation_id') {
            labels.push({ name: filterValue['rival_label'], value: filterValue['rival_label'], property: property })
          } else {
            labels.push({ name: filterValue[`${property}_label`], value: filterValue[`${property}_label`], property: property })
          }
        }
        continue;
      }

      if (property === 'unique_per_corporation') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: '企業をユニークにする', value: filterValue[property], property: 'unique_per_corporation' })
        }
        continue;
      }

      if (property === 'exclude_registered_address') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: '登録済みアドレスを除外', value: filterValue[property], property: 'exclude_registered_address' })
        }
        continue;
      }

      if (property === 'exclude_retirement_risk') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: '退任リスクのキーマンを除外', value: filterValue[property], property: 'exclude_retirement_risk' })
        }
        continue;
      }

      // 業種検索モードフィルター: INDUSTRY_SEARCH_MODE_CONFIGを使って動的にラベル生成
      if (INDUSTRY_SEARCH_MODE_CONFIG && INDUSTRY_SEARCH_MODE_CONFIG[property]) {
        const config = INDUSTRY_SEARCH_MODE_CONFIG[property];
        const val = filterValue[property];
        if (val && val !== config.initialValue) {
          const labelName = config.labelFormatter ? config.labelFormatter(val) : val;
          labels.push({ name: labelName, value: val, property });
        }
        continue;
      }

      // 資金調達フィルター: FUNDRAISING_FILTER_CONFIGを使って動的にラベル生成
      if (FUNDRAISING_FILTER_CONFIG && FUNDRAISING_FILTER_CONFIG[property]) {
        const config = FUNDRAISING_FILTER_CONFIG[property];
        const val = filterValue[property];

        if (config.type === 'set') {
          if (val && val.size > 0) {
            val.forEach(v => {
              labels.push({ name: config.labelFormatter(v), value: v, property });
            });
          }
        } else if (val) {
          // select型・boolean型
          labels.push({ name: config.labelFormatter(val), value: val, property });
        }
        continue;
      }

      if (property === 'show_recently_created') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: '新任を表示', value: filterValue[property], property: 'show_recently_created' })
        }
        continue;
      }

      if (property === 'exists_corporation_department_tels_filter') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: '部門電話番号あり', value: filterValue[property], property: 'exists_corporation_department_tels_filter' })
        }
        continue;
      }

      if (property === 'include_field_call_analysis_ids') {
        if (filterValue && filterValue[property]) {
          labels.push({ name: 'コール分析あり', value: filterValue[property], property: 'include_field_call_analysis_ids' })
        }
        continue;
      }

      if (MAP_MENU_CONFIG && MAP_MENU_CONFIG[property]) {
        const config = MAP_MENU_CONFIG[property];
        if (filterValue[property].count() > 0) {
          let names = flattenMap(filterValue[property], config.menu, 'name');
          let values = flattenMap(filterValue[property], config.menu, 'value');

          names.forEach((label, index) => {
            const entry = config.map[values[index]];
            labels.push({
              name: config.labelFormatter(label || values[index], entry),
              value: values[index],
              category: config.category,
              property: property
            });
          });
        }
      } else if ((MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG && MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[property])) {
        const config = MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG[property];
        if (filterValue[property].count() > 0) {
          let names = flattenMap(filterValue[property], config.menu, 'name');
          let values = flattenMap(filterValue[property], config.menu, 'value');

          names.forEach((label, index) => {
            const entry = config.map[values[index]];
            const rangeDate = config.dateRangeFormatter(filterValue, entry, label);
            labels.push({
              name: `${entry ? entry.parent_name + " : " + label : label}${rangeDate}`,
              value: values[index],
              category: config.category,
              property: property
            });
          });
        }
      } else if (KEYWORD_SEARCH_CONFIG && KEYWORD_SEARCH_CONFIG[property]) {
        if (filterValue[property] !== '') {
          labels.push({ name: KEYWORD_SEARCH_CONFIG[property].label, value: filterValue[property], property: property })
        }
      } else if (property === 'exclude_retirement') {
        if (filterValue[property] !== this.initialState.filterValue.exclude_retirement) {
          label = excludeRetirementMenu.find(menuItem => menuItem.value.toString() === filterValue[property]);
          labels.push({ ...label, category: '進退', property: property });
        }
      } else if (property === 'relocation_at') {
        if (filterValue[property].count() > 0) {
          let years = filterValue[property].keySeq().toArray();
          years.forEach(y => {
            let yearName = y + '年';

            if (filterValue[property].has(y) && filterValue[property].get(y).count() > 0) {
              let months = filterValue[property].get(y).toArray();
              months.forEach(m => {
                let monthName = m + '月';
                label = yearName + monthName;
                labels.push({ name: yearName + monthName, value: y.toString() + m.toString(), category: '着任', property: property });
              })
            } else if (y === 'before2020') {
              labels.push({ name: '2020年以前も表示する', value: y.toString(), category: '着任', property: property });
            } else {
              labels.push({ name: yearName, value: y.toString(), category: '着任', property: property });
            }
          })
        }
      } else if (property === 'cap_size_per_corporation') {
        if (Number(filterValue['cap_size_per_corporation']) > 0) {
          const cap_size_per_corporation = Object.values(capSizePerCorporationMenu).find(target => filterValue[property] === target.value)
          labels.push({ name: cap_size_per_corporation.name, value: filterValue['cap_size_per_corporation'], property: 'cap_size_per_corporation' })

          const cap_sort_first_preferred = Object.values(capSortMenu).find(target => filterValue['cap_sort_first_preferred'] === target.value)
          if (cap_sort_first_preferred && Number(cap_sort_first_preferred.value) > 0) {
            labels.push({ name: '第一優先 ' + cap_sort_first_preferred.name, value: filterValue['cap_sort_first_preferred'], property: 'cap_sort_first_preferred' })
          }
          const cap_sort_second_preferred = Object.values(capSortMenu).find(target => filterValue['cap_sort_second_preferred'] === target.value)
          if (cap_sort_second_preferred && Number(cap_sort_second_preferred.value) > 0) {
            labels.push({ name: '第二優先 ' + cap_sort_second_preferred.name, value: filterValue['cap_sort_second_preferred'], property: 'cap_sort_second_preferred' })
          }
        }
      } else if (
        property === 'cap_sort_first_preferred' ||
        property === 'cap_sort_second_preferred' ||
        property === 'sent_only_from' ||
        property === 'sent_only_to' ||
        property === 'sent_except_from' ||
        property === 'sent_except_to' ||
        property === 'corporation_sent_only_from' ||
        property === 'corporation_sent_only_to' ||
        property === 'corporation_sent_except_from' ||
        property === 'corporation_sent_except_to' ||
        property === 'follow_call_order_only_from' ||
        property === 'follow_call_order_only_to' ||
        property === 'follow_call_order_except_from' ||
        property === 'follow_call_order_except_to'
      ) {
        continue;
      } else if (SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG[property]) {
        const config = SIMPLE_MENU_FILTER_CONFIG[property];
        if (filterValue[property].count() > 0) {
          const set = filterValue[property].toArray();
          set.forEach(item => {
            label = config.menu.find(menuItem => menuItem.value.toString() === item.toString());
            labels.push({ ...label, category: config.category, property: property })
          })
        }
      }
    }

    if (isSearchCompanys) {
      labels.push({ name: '法人番号・会社名で一括検索', value: '法人番号・会社名で一括検索', property: 'companys' })
    }

    return labels;
  }

  postConfirmSendLetter = () => {
    let query = this.selectionToQuery();
    this.props.postSendExecutiveList(query)
  }

  confirmSendLetterDialogSet = (hasLetterOrderHistoryNames, duplicateNames, selectItem = null) => {
    this.setState({
      showConfirmSendDialog: true,
      hasLetterOrderHistoryNames: selectItem ? [selectItem.name] : hasLetterOrderHistoryNames,
      duplicateNames: selectItem ? [] : duplicateNames,  // キーマンを選択した場合は1通なので、注文内で重複はない
    });
  }

  goToSendLetter = () => {
    let query = {};

    if (this.state.item) {
      query['relocation_personnel_ids'] = this.state.item.id;
    } else {
      if (this.state.isSelectAll) {
        query = this.filterValueToQuery(this.state.filterValue);
        query['except_relocation_personnel_ids'] = this.state.unselectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      }
      query['relocation_personnel_ids'] = this.state.selectedItems.toArray();
    }

    this.props.goTo('/send-letter', {
        query: query,
        ids: this.getSelectedItemIds()(1), // 確認画面で任意の1件を表示する用途で使う
        count: this.getSelectedCount(),
        isExe: true,
        filter: {...this.filterValueToQuery(this.state.filterValue), 'perPage': this.state.perPage, 'page': this.props.pageInfo.current_page ? this.props.pageInfo.current_page : 1},
    })
  }

  /*** rendering functions ***/
  renderMainPanelHeader = () => {
    const { classes, pageInfo, corporationCount, isLoading } = this.props;

    let total = pageInfo && pageInfo.total_count_for_Display ? pageInfo.total_count_for_Display : 0;

    return (
      <div className={classes.mainPanelHeaderWrap}>
        <div className={classes.mainPanelHeader} style={{ pointerEvents: isLoading ? 'none' : 'auto' }}>
          <div style={{ minWidth: '265px' }}>
            <Typography variant="body1">該当件数</Typography>
            <div className={classes.mainPanelCountContent}>
              <Typography variant="display2">{addCommas(total)}人</Typography>
              <Typography variant="display1" style={{ marginLeft: '14px', fontSize: 13 }}>本日更新：{pageInfo && pageInfo.add_keyman_count ? addCommas(pageInfo.add_keyman_count) : 0}人</Typography>
            </div>
            <Typography variant="body2" style={{ marginTop: '2px' }}>(企業数：{addCommas(corporationCount)}社)</Typography>
          </div>
          {this.renderFilterChips()}

        </div>
      </div>
    )
  }

  renderBottomMenu = () => {
    const { user } = this.props;
    const isSalesforceEnabled = (
      user &&
      user.salesforce_integration_flag &&
      user.integrations &&
      user.integrations["salesforce"]
    );
    let count = this.getSelectedCount();
    let menu = [];

    if (this.props.enableExecutiveListAdvancedSearch || isEnabledExportExecutiveList(user)) {
      menu.push({
        text: "CSVダウンロード",
        action: this.toggleCsvDownloadDialog,
      })
    }

    if (
      (this.state.filterValue.sent_status.has(sentStatusMenu.find(menu => menu.name.toString() === "注文済みキーマンのみを表示").value) || this.state.filterValue.corporation_sent_status.has(corporationSentStatusMenu.find(menu => menu.name.toString() === "注文済み企業のみを表示").value)) &&
      user &&
      user.salesforce_integration_flag &&
      user.integrations &&
      user.integrations["salesforce"]
    ) {
      menu.push({
        text: "Salesforceに同期",
        action: isSalesforceEnabled ? this.toggleSalesforceSyncWarningDialog : this.togglePlanDialog,
      })
    }

    menu.push(
      {
        text: "リストに追加 / 削除",
        action: this.toggleEditTagsDialog,
        disabled: !isEnabledUserRole(user, "executive-list", "edit-tag"),
      },
      {
        text: "レター送付",
        action: (isEnabledSendLetter(user)) ? this.postConfirmSendLetter : this.togglePlanDialog,
        disabled: !isEnabledUserRole(user, "executive-list", "order-letter") || !isMinLetterOrderCount(user, count),
        disableMessage: this.disableLetterOrderMessage(),
      },
    )

    return (
      <BottomButtonMenu
        numSelected={count}
        deselectAll={() => this.handleSelectAll(false)}
        menuItems={menu}
        open={count > 0}
        isMinLetterOrderCount={isMinLetterOrderCount(user, count)}
        minLetterOrderCount={user && user.min_letter_order_count ? user.min_letter_order_count : 0}
      />);
  }

  disableLetterOrderMessage = () => {
    const { user, classes } = this.props;
    let errors = [];

    if (!isMinLetterOrderCount(user, this.getSelectedCount())) {
      const minLetterOrderCount = (user && user.min_letter_order_count) ? user.min_letter_order_count : 0;
      errors.push("レター送付は" + minLetterOrderCount + "件以上から注文可能です");
    }

    if (errors.length > 0) {
      return errors.map((msg, i) => (
        <span key={i} className={classes.errorMessageRow}>
          <CancelCircle
            width={12}
            height={12}
            color="#F03A47"
            style={{ marginRight: "2px" }}
          />
          {msg}
        </span>
      ));
    } else {
      return "";
    }
  };

  renderFilterChips = () => {
    const { classes } = this.props;
    let chips = [];
    let labels = this.filterValueToLabels();

    labels.forEach((label, i) => {
      chips.push(
        <Chip
          key={i}
          label={label.name}
          color="primary"
          classes={{
            root: classes.chipRoot,
            label: classes.chipLabel,
          }}
          onDelete={() => this.handleChipsDelete(label.property, label.value)}
          deleteIcon={<CancelCircle width={15} height={15} color="#6F9EFF" />}
        />
      )
    });

    if (chips.length > 0) {
      return (
        <div className={classes.chipContainer}>
          <Typography variant="body1">絞り込み条件</Typography>
          {chips}
          <Button
            text="絞り込み条件を保存"
            type="ghost"
            size="extra-small"
            handleClickButton={this.toggleSaveFilterDialog}
            style={{
              color: '#1A65FF',
              fontWeight: 'bold',
              border: 'none',
              width: 'unset',
              padding: '0px 5px',
              textDecoration: 'underline',
              marginTop: '8px',
              marginRight: '5px',
              minWidth: 'unset',
              float: 'left'
            }}
          />
          <Button
            text="絞り込み条件をリセット"
            type="ghost"
            size="extra-small"
            handleClickButton={this.clearFilterValues}
            style={{
              color: '#71737B',
              border: 'none',
              width: 'unset',
              padding: '0px 5px',
              textDecoration: 'underline',
              marginTop: '8px',
              marginRight: '5px',
              minWidth: 'unset',
              float: 'left'
            }}
          />
        </div>
      )
    }
  }

  renderPlanDialog = () => (
    <PlanDialog
      isOpen={this.state.showPlanDialog}
      toggleDialog={this.togglePlanDialog}
    />
  )

  renderDailyNotificationDialog = () => (
    <DailyNotificationDialog
      isOpen={this.state.showDailyNotificationDialog}
      toggleDialog={this.toggleDailyNotificationDialog}
      handleUpdateFilter={this.handleUpdateFilter}
      toggleExecDetailItemDialog={this.toggleExecDetailItemDialog}
    />
  )

  renderSalesforceSyncWarningDialog = () => (
    <SalesforceSyncWarningDialog
      isOpen={this.state.showSalesforceSyncWarningDialog}
      toggleDialog={this.toggleSalesforceSyncWarningDialog}
      handleSalesforceSync={this.handleSalesforceSync}
      isPostingSalesforceSync={this.props.isPostingSalesforceSync}
      isSalesforceExeSettingEnabled={this.props.exe_export_mappings_flag}
    />
  )

  renderListSettingDialog = () => {
    // AI生成タグが1つだけ選択されている場合はホット順ソートを含める
    // 複数のAI生成タグが選択されている場合はホット順ソートを無効化
    // 複数選択時はgetSelectedAiTagName()がnullを返すため、hotScoreTagNameがあっても無視する
    const selectedAiTagName = this.getSelectedAiTagName(); // 複数選択時はnullを返す
    // 複数選択時（selectedAiTagNameがnull）の場合は、hotScoreTagNameがあっても無視
    const aiTagName = selectedAiTagName !== null ? (this.state.hotScoreTagName || selectedAiTagName) : null;
    const sortTypes = aiTagName
      ? ExecSortType
      : Object.fromEntries(
          Object.entries(ExecSortType).filter(
            ([key]) => key !== 'SORT_TYPE_HOT_SCORE_ASC'
          )
        );

    // 複数選択時でホット順ソートが選択されている場合は、デフォルトのソート順に変更
    let currentSortType = this.state.sortType;
    if (!aiTagName && currentSortType === ExecSortType.SORT_TYPE_HOT_SCORE_ASC.value) {
      currentSortType = ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value;
      // 状態を更新（非同期なので、ダイアログ表示時には反映されないが、次回の検索には反映される）
      this.setState({
        sortType: currentSortType,
        hotScoreTagName: null,
      });
    }

    return (
      <ListSettingDialog
        isOpen={this.state.showListSettingDialog}
        toggleDialog={this.toggleListSettingDialog}
        sortType={currentSortType}
        sortTypes={sortTypes}
        perPage={this.state.perPage}
        disableSort={this.state.filterValue.unique_per_corporation || Number(this.state.filterValue.cap_size_per_corporation) > 0}
        handleChangeListSetting={this.handleChangeListSetting}
        isSaving={this.props.isLoading}
      />
    );
  }

  renderPromotePlanChangeDialog = (type) => {
    return (
      <PromotePlanChangeDialog
        isOpen={this.state[type["flag"]]}
        type={type}
        toggleDialog={() => this.togglePromotePlanChangeDialog(type)}
        handlePlanChange={this.togglePlanDialog}
      />
    );
  }

  renderSaveFilterDialog = () => (
    <SaveFilterDialog
      user={this.props.user}
      isOpen={this.state.showSaveFilterDialog}
      toggleDialog={this.toggleSaveFilterDialog}
      isPostingFilter={this.props.isPostingFilter}
      handlePostExecutiveListFilter={this.props.postExecutiveListFilters}
      filter={this.filterValueToQuery(this.state.filterValue)}
      filterValue={this.state.filterValue}
      labels={this.filterValueToLabels()}
    />
  )

  renderEditFilterDialog = () => (
    <EditFilterDialog
      isOpen={this.state.showEditFilterDialog}
      toggleDialog={this.toggleEditFilterDialog}
      filters={this.props.filters}
      patchExecutiveListFiltersById={this.props.patchExecutiveListFiltersById}
      deleteExecutiveListFiltersById={this.props.deleteExecutiveListFiltersById}
      patchingFilterId={this.props.patchingFilterId}
      deletingFilterId={this.props.deletingFilterId}
      isLoadingFilter={this.props.isLoadingFilter}
      handleFilterSelected={this.handleFilterSelected}
      errorMessage={this.props.errorMessage}
    />
  )

  getQuery = () => {
    let query = {};

    if (this.state.item) {
      query['relocation_personnel_ids'] = this.state.item.id;
    } else {
      if (this.state.isSelectAll) {
        query = this.filterValueToQuery(this.state.filterValue);
        query['except_relocation_personnel_ids'] = this.state.unselectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      }
      query['relocation_personnel_ids'] = this.state.selectedItems.toArray();
    }
    return query;
  }

  getFilter = () => {
    let filter = { ...this.filterValueToQuery(this.state.filterValue), 'perPage': this.state.perPage, 'page': this.props.pageInfo && this.props.pageInfo.current_page ? this.props.pageInfo.current_page : 1 }
    return filter;
  }

  renderExecDetailItemDialog = () => {
    if (this.state.item) {
      const query = this.getQuery();
      const filter = this.getFilter();
      const stateFilterValue = this.state.filterValue;

      // ユーザーのプランと選択したキーマンの送付状況でレター送付のアクションを変更する
      let sendLetterAction;
      if (isEnabledSendLetter(this.props.user)) {
        if (this.props.executiveListItem && this.props.executiveListItem.has_letter_order) {
          sendLetterAction = () => this.confirmSendLetterDialogSet([], [], this.state.item)
        } else {
          sendLetterAction = () => this.props.goTo(`/send-letter`, buildGoBackToExecutiveDetailParams(this.state.item, query, filter, stateFilterValue))
        }
      } else {
        sendLetterAction = () => this.togglePlanDialog();
      }

      // ExecDetailItemDialogコンポーネントのさらに下層のコンポーネントの各プロパティをまとめる（可読性のため）
      const executivePersonProps = {
        isLoadingExecutiveListItem: this.props.isLoadingExecutiveListItem,
        executiveListItem: this.props.executiveListItem,
        filterIntentKeywords: formatIntentKeywords(this.state.filterValue.reaction_keyword, getIntentKeywordMaps(this.state.filterValue)),
      }

      const timelineProps = {
        goToTimeline: () => this.props.goTo(`/executive-list/${this.state.item.executive_person_id}/timeline`, buildGoBackToExecutiveDetailParams(this.state.item, query, filter, stateFilterValue))
      }

      // ExecDetailItemDialogコンポーネントのさらに下層のコンポーネントの各プロパティをまとめる（可読性のため）
      const corporationRelationshipsKeymanProps = {
        handleFilterRivalKeyman: () => this.handleUpdateFilter({ ...this.initialState.filterValue, ...buildCorporationRelationshipsKeymanParams(this.props.executiveListItem, 'rival') }),
        handleFilterChildCorporationKeyman: () => this.handleUpdateFilter({ ...this.initialState.filterValue, ...buildCorporationRelationshipsKeymanParams(this.props.executiveListItem, 'child') }),
        handleFilterParentCorporationKeyman: () => this.handleUpdateFilter({ ...this.initialState.filterValue, ...buildCorporationRelationshipsKeymanParams(this.props.executiveListItem, 'parent') }),
        handleFilterSameDepartmentIncludeParentAndChildCorporationKeyman: () => this.handleUpdateFilter({ ...this.initialState.filterValue, ...buildCorporationRelationshipsKeymanParams(this.props.executiveListItem, 'same_department_include_parent_and_child') })
      };

      // ExecDetailItemDialogコンポーネントのさらに下層のコンポーネントの各プロパティをまとめる（可読性のため）
      const csvProps = {
        toggleCsvDownloadDialog: () => this.toggleCsvDownloadDialog(this.state.item)
      }

      return (
        <ExecDetailItemDialog
          user={this.props.user}
          isOpen={this.state.showExecDetailItemDialog && !!this.state.item}
          toggleDialog={this.toggleExecDetailItemDialog}
          toggleEditTagsDialog={() => this.toggleEditTagsDialog(this.state.item)}
          togglePromotePlanChangeDialog={($type) => this.togglePromotePlanChangeDialog($type)}
          goToSendLetter={sendLetterAction}
          enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
          {...executivePersonProps}
          {...timelineProps}
          {...corporationRelationshipsKeymanProps}
          {...csvProps}
        />
      );
    }
  }

  renderSelectOptionDialoog = () => {
    return (
      <SelectOptionDialog
        toggleDialog={this.toggleSelectOptionDialog}
        isOpen={this.state.showSelectOptionDialog}
        totalCount={this.props.pageInfo && this.props.pageInfo.total ?
          this.props.pageInfo.total : 0}
        handleSetSelectOption={this.handleSetSelectOption}
      />
    )
  }

  renderManageTagsDialog = () => {
    return (
      <ManageTagsDialog
        title="リストの管理"
        type={TagType.CUSTOM_TAG}
        toggleDialog={this.toggleManageTagsDialog}
        isOpen={this.state.showManageTagsDialog}
        tags={this.props.tags}
        deleteTag={(data) => this.props.postExecutiveListDeleteTags(data)}
        updateTagName={(data) => this.props.postExecutiveListUpdateTagName(data)}
        isUpdatingAddressTags={this.props.isUpdatingTags}
        isDeletingAddressTags={this.props.isDeletingTags}
        isLoadingSidebar={!!this.props.isLoadingSidebar}
        updateFilter={val => this.handleUpdateFilter({ ...this.initialState.filterValue, ...val })}
        errorMessage={this.props.errorMessage}
        chipsDelete={this.handleChipsDelete}
      />
    )
  }

  /**
   * 現在選択中のAI生成タグのIDを取得
   * AI生成タグは "AI生成_" で始まるタグ名を持つ
   * @returns {number|null} AI生成タグID、選択されていない場合はnull
   */
  /**
   * 選択中のAI生成タグ名を取得
   * hot_scoresは{tag_name: hot_score}形式のため、タグ名を返す
   * 複数のAI生成タグが選択されている場合はnullを返す（ホット順ソートを無効化）
   */
  getSelectedAiTagName = () => {
    const { filterValue } = this.state;

    // タグが選択されていない場合
    if (!filterValue || !filterValue.tag || filterValue.tag.size === 0) {
      return null;
    }

    // "AI生成_" で始まるタグ名を探す
    const selectedTagNames = filterValue.tag.toArray ? filterValue.tag.toArray() : Array.from(filterValue.tag);
    const aiTagNames = selectedTagNames.filter(name => name && name.startsWith('AI生成_'));

    // 複数のAI生成タグが選択されている場合はnullを返す（ホット順ソートを無効化）
    if (aiTagNames.length > 1) {
      return null;
    }

    // 1つだけの場合はそのタグ名を返す
    return aiTagNames.length === 1 ? aiTagNames[0] : null;
  }

  /**
   * 選択中のAI生成タグIDを取得（後方互換性のため残す）
   * @deprecated hot_scoresはtag_nameをキーに使用するため、getSelectedAiTagNameを使用すること
   */
  getSelectedAiTagId = () => {
    const { tags } = this.props;
    const aiTagName = this.getSelectedAiTagName();
    
    if (!aiTagName || !tags || tags.length === 0) {
      return null;
    }

    // タグ名からIDを検索
    const aiTag = tags.find(t => t.name === aiTagName);
    return aiTag ? aiTag.id : null;
  }

  handleAttackListTagCreated = (tagName) => {
    // タグリストを更新
    this.props.postExecutiveListGetTags();

    // filterValueにタグを追加してサイドバーのチェックを入れる
    const newFilterValue = {
      ...this.initialState.filterValue,
      tag: Set([tagName]),
    };

    // ホット順ソートを適用（AI生成タグの場合）
    this.setState({
      sortType: ExecSortType.SORT_TYPE_HOT_SCORE_ASC.value,
      hotScoreTagName: tagName,
    }, () => {
      this.handleUpdateFilter(newFilterValue);
    });
  }

  renderAttackListGeneratorDialog = () => {
    return (
      <AttackListGeneratorDialog
        isOpen={this.state.showAttackListGeneratorDialog}
        toggleDialog={this.toggleAttackListGeneratorDialog}
        // 2段階API
        postAttackListAnalyzeUrl={this.props.postAttackListAnalyzeUrl}
        postAttackListExecuteTagging={this.props.postAttackListExecuteTagging}
        clearAttackListState={this.props.clearAttackListState}
        // 2段階API用State
        isAnalyzingUrl={this.props.isAnalyzingUrl}
        isExecutingTagging={this.props.isExecutingTagging}
        attackListAnalysisId={this.props.attackListAnalysisId}
        // 結果
        attackListTag={this.props.attackListTag}
        attackListExtractedConditions={this.props.attackListExtractedConditions}
        attackListSummary={this.props.attackListSummary}
        attackListTaggedCount={this.props.attackListTaggedCount}
        attackListError={this.props.attackListError}
        onTagCreated={this.handleAttackListTagCreated}
      />
    )
  }

  renderEditTagsDialog = () => {
    return (
      <EditTagsDialog
        title="選択したキーマンをリストに追加 / 削除"
        toggleDialog={this.toggleEditTagsDialog}
        isOpen={this.state.showEditTagsDialog}
        tags={this.props.selectedAddressTags}
        isLoadingSelectedAddressTags={this.props.isLoadingSelectedAddressTags}
        getTags={this.props.postExecutiveListGetTags}
        saveTags={this.handleUpdateTags}
        deleteTag={(data) => this.props.postExecutiveListDeleteTags(data)}
        query={this.selectionToQuery()}
        isDeletingAddressTags={this.props.isDeletingTags}
        errorMessage={this.props.errorMessage}
        selectCount={this.state.item ? 1 : this.getSelectedCount()}
        isUpdatingTags={this.props.isUpdatingTags}
        options={this.props.tags}
        toggleCreateListDialog={this.toggleCreateListDialog}
        item={this.state.item}
      />
    )
  }

  renderCreateListDialog = () => {
    return (
      <CreateListDialog
        isOpen={this.state.showCreateListDialog}
        toggleDialog={this.toggleCreateListDialog}
        isUpdatingTags={this.props.isUpdatingTags}
        saveTags={this.handleUpdateTags}
        saveTagsWithQuery={(tags, overrideQuery, type) => this.handleUpdateTagsWithQuery(tags, overrideQuery, type)}
        overrideQuery={this.state.createListOverrideQuery}
        toggleEditTagsDialog={this.toggleEditTagsDialog}
      />
    )
  }

  handleUpdateTagsWithQuery = (tags, overrideQuery = null, type = TagType.CUSTOM_TAG) => {
    let query = overrideQuery || this.selectionToQuery();
    query['tags'] = tags;
    query['type'] = type;

    this.props.postExecutiveListUpdateTag(query);
  }

  renderCsvDownloadDialog = () => {
    return (
      <CsvDownloadDialog
        title="選択したキーマンのCSVをダウンロード"
        toggleDialog={this.toggleCsvDownloadDialog}
        isOpen={this.state.showCsvDownloadDialog}
        handleCsvExportAll={this.handleCsvExportAll}
        handleCsvExportOne={this.handleCsvExportOne}
        activePlan={this.props.user.active_plan}
        selectCount={this.getSelectedCount()}
        item={this.state.item}
        exportedList={this.props.exportedList}
      />
    )
  }

  renderConfirmSendDialog = () => {
    return (
      <ConfirmSendDialog
        isOpen={this.state.showConfirmSendDialog}
        toggleDialog={this.toggleConfirmSendDialog}
        duplicateNames={this.state.duplicateNames}
        hasLetterOrderHistoryNames={this.state.hasLetterOrderHistoryNames}
        action={this.state.item && this.state.showExecDetailItemDialog ?
          () => this.props.goTo(`/send-letter`, buildGoBackToExecutiveDetailParams(this.state.item, this.getQuery(), this.getFilter(), this.state.filterValue)) :
          () => this.goToSendLetter()
        }
      />
    );
  }

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
        </NotificationBar>
      </div>
    );
  };

  renderInfoBox = () => (
    <InfoBox
      inOpen={this.state.showInfoBox}
      toggleDialog={this.toggleInfoBox}
    />
  )

  renderBanner = () => {
    if (!isNaN(this.props.match.params.id) && this.props.user) {
      return (
        <Banner
          inOpen={this.state.showBanner}
          toggleDialog={this.toggleBanner}
        />
      )
    }
  }

  goBack = () => {
    this.props.goBack();
    this.props.replace(this.props.routerInfo.state.prevPath, { keepAddressBookState: true });
  }

  renderHeader = () => {
    const { routerInfo, classes } = this.props;
    if (routerInfo.state && routerInfo.state.hasOwnProperty('keepAddressBookState')) {
      return (
        <div className={classes.header}>
          <MuiButton
            className={classes.backBtn}
            onClick={this.goBack}
            color="default"
            aria-label="Back">
            <ArrowLeft color="#FFFFFF" width={20} height={20} />
          </MuiButton>
          <Typography variant="title" color="inherit" className={classes.title}>
            キーマンデータベース
          </Typography>
          <MuiButton
            className={classes.headerButton}
            onClick={this.goBack}>
            閉じる
          </MuiButton>
        </div>
      )
    } else {
      return (
        <Header title="キーマンデータベース" type="dark" hasBackBtn={false} />
      );
    }
  }

  setAddressTableContent = (node) => {
    this.addressTableContent = node;
  }

  renderList = () => {
    const { classes, pageInfo, executiveList, isLoading, isLoadingCheck, user } = this.props;

    if ((!this.state.isPageLoaded && isLoading) || isLoadingCheck) {
      return (
        <div className={classes.mainContainer}>
          <Loader type="color" size="large" />
        </div>
      )
    } else {
      return (
        <div className={classes.mainContainer}>
          <div className={classes.middleContainer} ref={this.setAddressTableContent}>
            <ExportCountNoticePanel
              user={user}
              showExportCountNotice={this.state.showExportCountNotice}
              onToggleExportCountNotice={this.toggleExportCountNotice}
            />

            {this.renderMainPanelHeader()}

            <NoMatchCorporationCsvExportPanel
              style={{ marginTop: "10px" }}
              isRender={this.state.showNoMatchCorporationCsvExportPanel} // 検索後に表示・非表示を決めるのでフラグで管理
              handleClick={() => this.props.postNoMatchCorporationCsv(this.queryToNoMatchCorporationQuery(this.filterValueToQuery(this.state.filterValue)))}
            />

            <div className={classes.mainPanel}>
              <div style={(!isEnabledDisplayExecutiveList(user)) ? { filter: 'blur(5px)', pointerEvents: 'none' } : {}}>
                <AddressTable
                  user={this.props.user}
                  goTo={this.props.goTo}
                  filteredItems={executiveList}
                  selectedItems={this.state.selectedItems}
                  unselectedItems={this.state.unselectedItems}
                  pageInfo={pageInfo}
                  totalCount={pageInfo ? pageInfo.not_regist_count : 0}
                  isSelectAll={this.state.isSelectAll}
                  selectCount={this.state.selectCount}
                  handleSelectAll={this.handleSelectAll}
                  handleSelectItem={this.handleSelectItem}
                  disabled={this.props.isLoading || this.disableExecutiveList()}
                  disableSort={this.state.filterValue.unique_per_corporation || Number(this.state.filterValue.cap_size_per_corporation) > 0}
                  filterIntentKeywords={formatIntentKeywords(this.state.filterValue.reaction_keyword, getIntentKeywordMaps(this.state.filterValue))}
                  enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
                  toggleSelectOptionDialog={this.toggleSelectOptionDialog}
                  togglePlanDialog={this.togglePlanDialog}
                  toggleCsvDownloadDialog={this.toggleCsvDownloadDialog}
                  toggleExecDetailItemDialog={this.toggleExecDetailItemDialog}
                  toggleListSettingDialog={this.toggleListSettingDialog}
                  togglePromotePlanChangeDialog={() => this.togglePromotePlanChangeDialog(PromotePlanDialogTypes.REACTION_KEYWORD)}
                  selectedAiTagName={this.getSelectedAiTagName()}
                />
              </div>
            </div>

            {executiveList.length > 0 && pageInfo && (
              <div className={classes.paginationContainer}>
                <Pagination
                  currentPage={pageInfo.current_page}
                  lastPage={pageInfo.last_page}
                  total={pageInfo.total_count_for_Display}
                  perPage={this.state.perPage}
                  showLastPage={false}
                  disabled={this.props.isLoading}
                  disableNavigation={this.disablePagination()}
                  togglePlanDialog={this.togglePlanDialog}
                  onChange={(data) => {
                    let query = this.filterValueToQuery(this.state.filterValue);
                    this.props.postExecutiveListSearch({ ...query, ...data }, true)
                  }}
                />
              </div>
            )}

            <div className={classes.bottomMenu} style={{ transform: (this.getSelectedCount() === 0) ? 'scaleY(0)' : 'scaleY(1)' }}>
              {this.renderBottomMenu()}
            </div>
          </div>
        </div>
      )
    }
  }

  render() {
    const { classes } = this.props;
    let saveFilterDialog, editFilterDialog, notification, execDetailItemDialog,
      selectOptionDialog, infoBox, banner, planDialog, manageTagsDialog, editTagsDialog, createListDialog, csvDownloadDialog, listSettingDialog, promoteReactionKeywordDialog, promoteDepartmentTelDialog, salesforceSyncWarningDialog, confirmSendDialog, showDailyNotificationDialog, attackListGeneratorDialog;
    if (this.state.showSaveFilterDialog) { saveFilterDialog = this.renderSaveFilterDialog(); }
    if (this.state.showEditFilterDialog) { editFilterDialog = this.renderEditFilterDialog(); }
    if (this.state.showNotification) { notification = this.renderNotification(); }
    if (this.state.showExecDetailItemDialog && !!this.state.item) { execDetailItemDialog = this.renderExecDetailItemDialog(); }
    if (this.state.showInfoBox) { infoBox = this.renderInfoBox(); }
    if (this.state.showBanner) { banner = this.renderBanner(); }
    if (this.state.showSelectOptionDialog) { selectOptionDialog = this.renderSelectOptionDialoog(); }
    if (this.state.showPlanDialog) { planDialog = this.renderPlanDialog(); }
    if (this.state.showManageTagsDialog) { manageTagsDialog = this.renderManageTagsDialog(); }
    if (this.state.showAttackListGeneratorDialog) { attackListGeneratorDialog = this.renderAttackListGeneratorDialog(); }
    if (this.state.showEditTagsDialog) { editTagsDialog = this.renderEditTagsDialog(); }
    if (this.state.showCreateListDialog) { createListDialog = this.renderCreateListDialog(); }
    if (this.state.showCsvDownloadDialog) { csvDownloadDialog = this.renderCsvDownloadDialog(); }
    if (this.state.showListSettingDialog) { listSettingDialog = this.renderListSettingDialog(); }
    if (this.state[PromotePlanDialogTypes.REACTION_KEYWORD.flag]) { promoteReactionKeywordDialog = this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.REACTION_KEYWORD); }
    if (this.state[PromotePlanDialogTypes.DEPARTMENT_TEL.flag]) { promoteDepartmentTelDialog = this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.DEPARTMENT_TEL); }
    if (this.state.showSalesforceSyncWarningDialog) { salesforceSyncWarningDialog = this.renderSalesforceSyncWarningDialog(); }
    if (this.state.showConfirmSendDialog) { confirmSendDialog = this.renderConfirmSendDialog(); }
    if (this.state.showDailyNotificationDialog) { showDailyNotificationDialog = this.renderDailyNotificationDialog(); }

    return (
      <Wrapper className={classes.root}>
        <NotificationBanner user={this.props.user} />
        <IsMaxExportExecutiveListNotification user={this.props.user} action={this.togglePlanDialog} />
        <IsMaxLetterSendingNotification user={this.props.user} action={this.togglePlanDialog} />
        {this.renderHeader()}

        <div className={classes.main}>
          <div className={classes.content}>
            <div className={classes.sidebar}>
              <ExecListSidebar
                isFiltering={this.props.isLoading}
                enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
                updateFilter={this.handleUpdateFilter}
                filterValue={this.state.filterValue}
                handleExcludeRegisteredAddress={this.handleExcludeRegisteredAddress}
                filters={this.props.filters}
                industryCategoryList={this.props.industryCategoryList}
                handleFilterSelected={this.handleFilterSelected}
                selectedFilter={this.state.selectedFilter}
                toggleEditFilterDialog={this.toggleEditFilterDialog}
                disabled={this.disableSidebar(this.props)}
                user={this.props.user}
                isDetail={!isNaN(this.props.match.params.id)}
                tags={this.props.tags}
                toggleManageTagsDialog={this.toggleManageTagsDialog}
                toggleAttackListGeneratorDialog={this.toggleAttackListGeneratorDialog}
                togglePlanDialog={this.togglePlanDialog}
                togglePromotePlanChangeDialog={() => this.togglePromotePlanChangeDialog(PromotePlanDialogTypes.REACTION_KEYWORD)}
                displayNotification={this.displayNotification}
                letterOrderList={this.props.letterOrderList}
                followCallOrderList={this.props.followCallOrderList}
                researchedTelHasDepartmentKeys={this.props.researchedTelHasDepartmentKeys}
              />
            </div>

            {this.renderList()}

            {saveFilterDialog}
            {editFilterDialog}
            {notification}
            {execDetailItemDialog}
            {infoBox}
            {banner}
            {selectOptionDialog}
            {planDialog}
            {manageTagsDialog}
            {attackListGeneratorDialog}
            {editTagsDialog}
            {createListDialog}
            {csvDownloadDialog}
            {listSettingDialog}
            {salesforceSyncWarningDialog}
            {confirmSendDialog}
            {showDailyNotificationDialog}
            {promoteReactionKeywordDialog}
            {promoteDepartmentTelDialog}
          </div>
          {this.props.enableExecutiveListAdvancedSearch && (
            <React.Fragment>
              <div className={classes.chatButton} onClick={this.handleChatDrawerToggle}>
                <Chat color="#FFFFFF" width={48} height={48} />
              </div>
              <ChatDrawer
                open={this.state.showChatDrawer}
                onClose={this.handleChatDrawerToggle}
                messages={this.state.chatMessages}
                onSubmit={this.sendMessageWithText}
                isLoading={this.state.isChatLoading}
                getTags={this.props.postExecutiveListGetTags}
                options={this.props.tags}
                isUpdatingTags={this.props.isUpdatingTags}
                isDeletingAddressTags={this.props.isDeletingTags}
                errorMessage={this.props.errorMessage}
                toggleCreateListDialog={this.toggleCreateListDialog}
                postExecutiveListUpdateTag={this.props.postExecutiveListUpdateTag}
                getWebCandidateKeymen={this.props.getWebCandidateKeymen}
                conversations={this.state.conversations}
                currentConversationId={this.state.currentConversationId}
                onNewChat={this.handleNewChat}
                onSelectConversation={this.handleSelectConversation}
                onDeleteConversation={this.handleDeleteConversation}
                onSeeAllConditions={this.handleSeeAllConditions}
              />
            </React.Fragment>
          )}
        </div>
      </Wrapper>
    );
  }
}

ExecutiveList.propTypes = {
  classes: PropTypes.object.isRequired,
  cookies: instanceOf(Cookies).isRequired,
  showInfoBox: PropTypes.bool,
  user: PropTypes.object,
  filters: PropTypes.array,
  tags: PropTypes.array,
  isLoading: PropTypes.bool,
  isLoadingCheck: PropTypes.bool,
  isLoadingSidebar: PropTypes.number,
  isLoadingFilter: PropTypes.bool,
  isLoadingExecutiveListItem: PropTypes.bool,
  isPostingFilter: PropTypes.bool,
  isPostingSalesforceSync: PropTypes.bool,
  isUpdatingTags: PropTypes.bool,
  isDeletingTags: PropTypes.bool,
  routerInfo: PropTypes.object,
  pageInfo: PropTypes.object,
  replace: PropTypes.func,
  getUserInfo: PropTypes.func,
  postIpCheck: PropTypes.func,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  executiveListAdvancedSearchIpCheckLoading: PropTypes.bool,
  getExecutiveListFilters: PropTypes.func,
  postExecutiveListGetTags: PropTypes.func,
  getSalesforceConfig: PropTypes.func,
  getLetterOrderList: PropTypes.func,
  getFollowCallOrderList: PropTypes.func,
  match: PropTypes.object,
  postExecutiveListSearch: PropTypes.func,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isLoadingCsv: PropTypes.bool,
  showBanner: PropTypes.bool,
  hasLetterOrderHistoryNames: PropTypes.array,
  duplicateNames: PropTypes.array,
  getExecutiveListById: PropTypes.func,
  clearExecutiveList: PropTypes.func,
  postExecutiveListFilters: PropTypes.func,
  patchExecutiveListFiltersById: PropTypes.func,
  deleteExecutiveListFiltersById: PropTypes.func,
  patchingFilterId: PropTypes.number,
  deletingFilterId: PropTypes.number,
  postExecutiveListUpdateTagName: PropTypes.func,
  postExecutiveListDeleteTags: PropTypes.func,
  postNoMatchCorporationCsv: PropTypes.func,
  postExecutiveListCopyLog: PropTypes.func,
  postExecutiveListSearchAi: PropTypes.func,
  postExecutiveListBuildConditionsAi: PropTypes.func,
  getWebCandidateKeymen: PropTypes.func,
  getAiWebResult: PropTypes.func,
  aiSearchResponse: PropTypes.any,
  isLoadingSelectedAddressTags: PropTypes.bool,
  selectedAddressTags: PropTypes.array,
  getExecutiveListItem: PropTypes.func,
  executiveListItem: PropTypes.object,
  postExecutiveListCsv: PropTypes.func,
  postExecutiveListUpdateTag: PropTypes.func,
  postExecutiveListSalesforceSync: PropTypes.func,
  setShowInfoBox: PropTypes.func,
  setShowBanner: PropTypes.func,
  getExportedList: PropTypes.func,
  selectExecutivePerson: PropTypes.object,
  goTo: PropTypes.func,
  goBack: PropTypes.func,
  executiveList: PropTypes.array,
  postSendExecutiveList: PropTypes.func,
  corporationCount: PropTypes.number,
  exe_export_mappings_flag: PropTypes.bool,
  exportedList: PropTypes.object,
  letterOrderList: PropTypes.array,
  followCallOrderList: PropTypes.array,
  getResearchedTelHasDepartments: PropTypes.func,
  researchedTelHasDepartmentKeys: PropTypes.array,
  getIndustryCategoryList: PropTypes.func,
  industryCategoryList: PropTypes.array,
  // AttackList関連
  clearAttackListState: PropTypes.func,
  isLoadingAttackList: PropTypes.bool,
  attackListTag: PropTypes.object,
  attackListExtractedConditions: PropTypes.object,
  attackListSummary: PropTypes.string,
  attackListTaggedCount: PropTypes.number,
  attackListError: PropTypes.object,
  // 2段階API
  postAttackListAnalyzeUrl: PropTypes.func,
  postAttackListExecuteTagging: PropTypes.func,
  isAnalyzingUrl: PropTypes.bool,
  isExecutingTagging: PropTypes.bool,
  attackListAnalysisId: PropTypes.string,
};

export default withCookies(withStyles(styles)(ExecutiveList));



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/ExecutiveList.jsx